// src/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en',
    lng: "en", // Explicitly set default language
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          // General Utility
          "app_name": "Gadd Kaam SkillSwap Pakistan",
          "dark_mode_toggle": "Toggle dark mode",
          "change_language": "Change language",
          "call_helpline": "Call helpline",
          "by_label": "by",
          "cannot_request_own_skill" : "You Can't Request Your Own Skill",
          "remotely_label": "Remotely",
          "anonymous_label": "Anonymous",
          "women_only_zone_tag": "Women's Zone",
          "not_specified": "Not specified",
          "ok": "Ok",
          "all_rights_reserved": "All rights reserved.",
          "confirm": "Confirm","offer_a_skill_title": "Offer a Skill",
"offer_a_skill_subtitle": "Share your expertise with the community",
"fill_all_required_fields": "Please fill in all required fields (Title, Description, Location).",
"cover_photo_label": "Cover Photo",
"click_to_upload": "Click to upload image",
"skill_title_label": "Skill Title (e.g., Web Development, Plumbing)",
"skill_title_placeholder": "Enter skills separated by commas...",
"description_label": "Description",
"description_placeholder": "Describe what you can do...",
"skills_wanted_label": "Skills Wanted in Return (Optional)",
"skills_wanted_placeholder": "e.g. Graphic Design, Gardening...",
"location_label": "Location",
"location_placeholder": "City, Area",
"remote_work_label": "Remote Work",
"remote_work_desc": "Service can be provided online",
"post_anonymously_label": "Post Anonymously",
"post_anonymously_desc": "Hide your name on the card",
"women_only_zone_label": "Women-Only Zone",
"women_only_zone_desc": "Visible only to female users",
"post_skill_offer_btn": "Post Skill Offer",
"live_preview_title": "Live Preview",
"live_preview_desc": "This is how your card will appear in the marketplace.",
"your_skill_title": "Your Skill Title",
"anonymous_user": "Anonymous User",
"skill_posted_success_title": "Skill Posted!",
"skill_posted_success_message": "Your skill offer has been successfully posted to the marketplace.",
"offer_publish_error_message": "Failed to publish skill offer. Please try again.",
          
          // Request Modal Specifics (Fixing missing keys)
          "specify_skill_wanted_label": "Specify the skill you want from them:",
          "request_skill_placeholder": "e.g., I need help with React.js tutoring in exchange for web design.",
          "work_can_be_remote_label": "Can this work be done remotely?",
          "location_label": "Location",
          "enter_location_placeholder": "e.g. Karachi, Pakistan",
          "send_request_btn": "Send Request",
          "sending_request_btn": "Sending...",
          "initial_request_message": "Hi, I am interested in swapping skills for: {{skill}}.",
          // --- Admin & Report Features ---
      "navbar_admin_dashboard": "Admin Dashboard",
      "navbar_admin_users": "Manage Users",
      "navbar_admin_skills": "Manage Skills",
      "navbar_admin_reports": "Manage Reports",
      
      "report_btn": "Report User",
      "report_user_title": "Report {{name}}",
      "report_user_desc": "Please select a reason for reporting this user. This report and the chat history will be reviewed by our admin team.",
      "submit_report_btn": "Submit Report",
      "report_submitted_success": "Report submitted successfully. Our team will review it shortly.",
      "cancel_btn": "Cancel",

      // --- New Footer Links ---
      "footer_quick_links": "Quick Links",
      "footer_support": "Support",
      "footer_follow_us": "Follow Us",
      "faq_link": "FAQs",
      "dispute_resolution_link": "Dispute Resolution",
      "footer_privacy_policy": "Privacy Policy",
      "footer_terms_of_service": "Terms of Service",
          // Request Errors & Success
          "request_sent_success_title": "Request Sent!",
          "request_sent_success_message": "Request sent successfully!",
          "request_sent_error_title": "Request Failed",
          "request_sent_error_message": "Failed to send request. Please try again.",
          "please_specify_skill_error": "Please specify the skill you want in return.",
          "location_required_non_remote_error": "Location is required for non-remote requests.",
          "failed_to_send_request_error": "Failed to send request. Please try again.",
          "access_denied_female_only": "Access Denied: This zone is for female users only.",
          "failed_to_load_women_only_skills_error": "Failed to load women-only skills. Please try again.",
          "failed_to_load_marketplace_skills_error": "Failed to load marketplace skills. Please try again.",


          // Received Requests Page
          "offered_by": "Offered by",
          "received_requests_page_title": "Received Requests",
          "received_requests_page_subtitle": "Manage skill swap requests from other community members.",
          "no_requests_received": "You haven't received any skill requests yet.",
          "requested_by": "Requested by",
          "offered_skill_label_in_request": "Offered Skill",
          "message_label": "Message",
          "date_received": "Date Received",
          "accept_btn": "Accept",
          "decline_btn": "Decline",
          "requested_your_skill": "Requested your skill",
          "sender_offers_in_return": "Sender offers in return",
          "cancel_btn": "Cancel",
          "request_accepted_by": "Request Accepted by {{username}}! 🎉",
          "contact_them_to_coordinate": "You can now contact them to coordinate your skill swap.",
          "contact_details_heading": "Contact Details:",
          "name_label": "Name",
          "phone_label": "Phone",
          "failed_to_load_requests_error": "Failed to load requests. Please try again.",
          "request_accepted_notification": "Request accepted! The user has been notified.",
          "failed_to_accept_request_error": "Failed to accept request. Please try again.",
          "request_cancelled_notification": "Request cancelled.",
          "failed_to_cancel_request_error": "Failed to cancel request. Please try again.",
          "pending_requests_section_title": "Pending Requests",
          "accepted_requests_section_title": "Accepted Requests",
          "no_new_requests_message_p1": "You currently have no new skill requests or accepted swaps.",
          "no_new_requests_message_p2": "When someone requests one of your skills, it will appear here.",
          "your_request_accepted_by": "Your request accepted by",
          "message_btn": "Message",
          "quick_actions": "Quick Actions",
          


          // Navbar
          "navbar_home": "Home",
          "navbar_about_us": "About Us",
          "navbar_women_zone": "Women's Zone",
          "navbar_contact": "Contact",
          "navbar_login_btn": "Log In",
          "navbar_signup_btn": "Sign Up",
          "navbar_logout": "Logout",
          "navbar_dashboard": "Dashboard",
          "navbar_my_profile": "My Profile",
          "navbar_my_skills": "My Skills",
          "navbar_messages": "Messages",
          "navbar_marketplace": "Marketplace",
          "navbar_reviews": "Reviews",
          "navbar_notifications": "Notifications",
          "navbar_helpline": "Helpline",

          // Hero Section
          "hero_headline": "Trade Skills, Build Futures.",
          "hero_subtext": "Gadd Kaam – SkillSwap Pakistan is a community where you can exchange your talents for the help you need, all without money.",
          "hero_offer_skill_btn": "Offer a Skill",
          "hero_find_skill_btn": "Find a Skill",
          "hero_title": "Connect with Local Talent",
          "hero_subtitle": "Your one-stop destination for finding and offering local services in Pakistan.",
          "hero_join_now": "Join Now",
          "hero_find_service": "Find a Service",
          "hero_find_service_desc": "Browse a wide range of services offered by skilled professionals in your area.",
          "hero_offer_skills": "Offer Your Skills",
          "hero_offer_skills_desc": "Create a profile and start earning by offering your services to the community.",
          "hero_secure_reliable": "Secure & Reliable",
          "hero_secure_reliable_desc": "We provide a secure platform for all transactions and communications.",


          // How It Works Section
          "how_it_works_title": "How It Works",
          "how_it_works_subtitle": "Joining our community is easy. Follow these simple steps to start swapping skills.",
          "step1_title": "1. Create Profile",
          "step1_description": "Sign up and list the skills you can offer. Get verified to build trust.",
          "step2_title": "2. Find & Swap",
          "step2_description": "Browse skills you need, or post a request. Connect with others to arrange a swap.",
          "step3_title": "3. Rate & Earn",
          "step3_description": "Complete the swap, leave feedback, and earn Skill Points for your contributions.",

          // Featured Skills Section
          "featured_skills_title": "Featured Skills",
          "view_all_link": "View All →",
          "view_details_link": "View Details →",

          // Testimonials Section
          "testimonials_title": "What Our Community Says",
          "testimonial1_quote": "I fixed my neighbor's water pump, and in return, his wife taught my daughter how to embroider. Gadd Kaam – SkillSwap made it possible. This is a blessing for our village.",
          "testimonial1_author_name": "Iqbal Hussain",
          "testimonial1_author_details": "Mechanic, Punjab",
          "testimonial2_quote": "As a woman, it's not always easy to find work. Through the women-only zone, I found a safe space to offer my sewing skills and learn accounting from another woman.",
          "testimonial2_author_name": "Samina Akhtar",
          "testimonial2_author_details": "Home Chef, Sindh",

          // Women's Zone Section
          "women_zone_title": "A Safe Space for Women",
          "women_zone_description": "Our Women-Only Skill Zone provides a secure and supportive environment for women to connect, learn, and trade skills with confidence.",
          "women_zone_button": "Explore the Women's Zone",

          // Footer
          "footer_tagline": "Empowering communities by connecting skills, cash-free.",
          "women-only-banner":"Secure & Verified Space for Women",
          "women_only_zone_banner_text":"Secure & Verified Space for Women",
          "footer_quick_links": "Quick Links",
          "footer_support": "Support",
          "footer_follow_us": "Follow Us",
          "footer_copyright": "Gadd Kaam – SkillSwap Pakistan. All rights reserved.",
          "footer_privacy_policy": "Privacy Policy",
          "footer_terms_of_service": "Terms of Service",
          "Empowering_communities_by_connecting_skills_cash_free": "Empowering communities by connecting skills, cash-free.",
          "post_a_skill": "Post a Skill",
          "faq_link": "FAQ",
          "dispute_resolution_link": "Dispute Resolution",


          // Language names for display
          "lang_en": "English",
          "lang_ur": "Urdu",
          "lang_sd": "Sindhi",

          // --- Dashboard Translations ---
          "dashboard_welcome_heading": "Welcome back, {{username}}!",
          "dashboard_sub_heading": "Here's a quick overview of your SkillSwap activity.",
          "skills_offered_title": "Skills Offered",
          "skills_offered_detail": "Post a skill to get started!",
          "skills_received_title": "Skills Received",
          "skills_received_detail": "Start learning new things today!",
          "unread_messages_title": "Unread Messages",
          "unread_messages_detail": "No new messages yet.",
          "find_skill_title": "Find a Skill",
          "find_skill_description": "Explore the marketplace to discover new skills and connect with talented people in your community.",
          "browse_marketplace_btn": "Browse Marketplace",
          "offer_skill_title_card": "Offer a Skill",
          "offer_skill_description_card": "Share your expertise with the community. Post a skill you can teach or a service you can provide.",
          "post_new_skill_btn": "Post a New Skill",

          // --- Profile Page Translations ---
          "profile_page_title": "My Profile",
          "profile_update_prompt": "Update your photo and personal details here.",
          "change_picture_btn": "Change Picture",
          "full_name_label": "Full Name",
          "email_address_label": "Email Address",
          "phone_number_label": "Phone Number",
          "location_label": "Location",
          "about_me_label": "About Me",
          "discard_changes_btn": "Discard Changes",
          "save_changes_btn": "Save Changes",
          "my_badges_title": "My Badges",

          // --- Offer Skill Page Translations ---
          "offer_skill_title": "Offer a New Skill",
          "offer_skill_subtitle": "Share your skills and connect with others in your community!",
          "step1_offer_skill": "Step 1: What can you offer?",
          "step1_offer_skill_desc": "Share your expertise and help others while learning something new! Choose up to 3 skills you’re confident in from the list below, or search for your own.",
          "step1_offer_skill_label": "Which top skills would you love to offer others?",
          "step1_offer_skill_placeholder": "Search for skills to offer...",
          "step2_offer_skill": "Step 2: Add more details",
          "step2_offer_skill_desc": "Add an optional photo and a description to make your listing stand out. Provide your location and contact details to help people connect with you.",
          "step2_photo_label": "Upload a Photo (Optional)",
          "step2_description_label": "Description",
          "step2_description_placeholder": "Describe what you’re offering in more detail...",
          "step2_location_label": "Location",
          "step2_location_placeholder": "e.g., Jamshoro, Pakistan",
          "step2_go_anonymous_switch": "Go Anonymous",
          "step2_remotely_switch": "Available Remotely",
          "step2_women_zone_switch": "Share in Women-Only Zone Only",
          "step3_offer_skill": "Step 3: What do you want in return?",
          "step3_offer_skill_desc": "Tell us what skills you’d like to swap for and discover new opportunities! Pick up to 3 skills you want to learn or improve from the list.",
          "step3_offer_skill_label": "What new skills are you excited to swap for?",
          "step3_offer_skill_placeholder": "Search for skills you want to learn...",
          "step4_offer_skill": "Step 4: Review & Publish",
          "step4_offer_skill_desc": "Please review all the details below. If everything looks good, publish your offer to the marketplace.",
          "step4_review_message": "By confirming, you agree to our Terms of Service and Privacy Policy.",
          "step4_confirm_publish_btn": "Confirm & Publish",
          "go_back_btn": "Back",
          "next_btn": "Next",

          // --- My Skills Page Translations ---
          "my_skills_page_title": "My Offered Skills",
          "my_skills_page_subtitle": "Manage your active skill offers and track their performance.",
          "no_skills_offered": "You haven't offered any skills yet. Post one to get started!",
          "view_full_details_btn": "View Details",
          "delete_offer_btn": "Delete Offer",
          "offer_skill_label": "Offered Skill",
          "swap_skill_label": "Wanted Skill",
          "description_label": "Description",
          "skill_not_specified": "Not specified",
          "yes": "Yes",
          "no": "No",
          "failed_to_load_my_skills_error": "Failed to load your skills. Please try again.",
          "skill_offer_deleted_success": "Skill offer deleted successfully!",
          "failed_to_delete_skill_offer_error": "Failed to delete skill offer. Please try again.",
          "delete_confirm_title": "Confirm Deletion",
          "delete_confirm_message": "Are you sure you want to delete this skill offer? This action cannot be undone.",

          // --- Marketplace Page Translations ---
          "marketplace_page_title": "Skill Marketplace",
          "marketplace_page_subtitle": "Explore skills offered by others in your community.",
          "no_skills_available": "No skills available in the marketplace right now. Check back later!",
          "request_btn": "Request",
          "search_skills_placeholder": "Search skills...",
          "no_categories_available": "No categories available.",
          "no_skills_match_filters": "No skills match your filters.",
          "no_skills_available_from_others": "No skills available from other users yet.",

          // --- Women Only Zone Page Translations ---
          "women_only_zone_page_title": "Women-Only Skill Zone",
          "women_only_zone_page_subtitle": "A dedicated space for women to safely share and swap skills.",
          "no_women_zone_skills_available": "No skills available in the Women-Only Zone right now. Check back later!",

          // --- Messages Page Translations (New) ---
          "messages_page_title": "My Messages",
          "messages_page_subtitle": "View and manage your conversations with other users.",
          "no_messages_yet": "You don't have any messages yet.",
          "search_messages_placeholder": "Search messages...",
          "no_messages_found": "No conversations found.",
          "select_conversation_message": "Select a conversation",
          "choose_chat_to_start": "Choose a chat from the left to start messaging.",
          "chat_with_user_placeholder": "Chat",
          "skill_received_btn": "Skill Received",
          "report_btn": "Report",
          "type_your_message_placeholder": "Type your message...",
          "chat_initial_greeting": "Hello there! How can I assist you today?",
          "chat_how_can_i_help": "I am ready when you are!",
          "chat_user_response": "Great, I'm looking forward to it!",
          "chat_message_ali": "Sure, let's meet tomorrow.", 
          "chat_message_fatima": "I received the skill!", 
          "chat_message_usman": "Initial message for a new request.", 
          "chat_message_ayesha": "Exchange completed. Please leave a review!", 
          "exchange_completed_chat_view_only": "This exchange is completed. You can no longer send messages.",
          "exchange_completed_no_chat": "This exchange is completed.",
          "exchange_completed_chat_summary": "Exchange completed. Please leave a review!",
          "confirm_skill_received_title": "Confirm Skill Received?",
          "confirm_skill_received_message": "Did you really receive the skill? This action cannot be undone and will lead to the review process.",
          "error_confirming_skill_received": "Failed to confirm skill received. Please try again.",
          "error_confirming_skill_received_generic": "Failed to confirm skill received. An error occurred.",
          "error_no_request_id": "Could not confirm skill. Request ID is missing.",
          "error_title": "Error",
          "your_confirmation_pending": "Your confirmation pending",
          "partner_confirmation_pending": "Partner confirmation pending",
          "exchange_completed_label": "Exchange Completed",


          // --- Reviews Page Translations (New) ---
          "reviews_page_title": "Reviews",
          "reviews_page_subtitle": "Share your feedback on completed skill exchanges and view reviews you've received.",
          "no_reviews_yet": "You haven't received any reviews yet.",
          "review_submitted_title": "Review Submitted!",
          "review_submitted_message": "Thank you for your feedback. Your review helps build trust in the community.",
          "back_to_dashboard_btn": "Back to Dashboard",
          "rate_skill_exchange_with": "Rate your skill exchange with {{username}}",
          "your_review_label": "Your Review",
          "review_placeholder": "Write your review here...",
          "endorse_skills_label": "Endorse skills for {{username}}",
          "endorse_btn": "Endorse",
          "submit_review_btn": "Submit Review",
          "reviews_received_tab": "Reviews Received",
          "write_a_review_tab": "Write a Review",
          "no_received_reviews_yet": "You haven't received any reviews yet.",
          "no_pending_reviews": "No pending reviews. All completed exchanges have been reviewed by you!",
          "review_for_exchange_with": "Review for exchange with {{username}}",
          "skills_involved": "Skills involved:",
          "skill_offered_by_them": "Skill offered by them:",
          "skill_you_requested": "Skill you requested:",
          "rating_label": "Rating:",
          "by_reviewer_name": "by {{username}}",
          "failed_to_submit_review": "Failed to submit review. Please try again.",
          "failed_to_load_received_reviews": "Failed to load received reviews.",
          "failed_to_load_pending_reviews": "Failed to load pending reviews.",
          "endorse_skills_optional": "Endorse skills (optional)",
          "skill_offered_label": "Skill Offered",
          "skill_requested_label": "Skill Requested",
          "review_submission_status": "Review Submission Status",
          "review_submitted_success": "Your review has been submitted successfully!",
          "failed_to_submit_review_error": "Failed to submit review. Please try again.",
          "please_provide_rating": "Please provide a rating.",
          "please_provide_review_comment": "Please provide a review comment.",
          "your_comments_label": "Your comments",
          "review_comment_placeholder": "Share your experience...",
          "rate_exchange_label": "Rate this exchange",
          "write_review_for_label": "Write a Review for {{username}}",
          "no_received_reviews": "No reviews received yet.",
          "received_reviews_tab": "Received Reviews",
          "app_name": "Gadd Kaam – SkillSwap Pakistan",
      
      // --- Navbar ---
      "navbar_home": "Home",
      "navbar_marketplace": "Marketplace",
      "navbar_women_zone": "Women's Zone",
      "navbar_about_us": "About Us",
      "navbar_contact": "Contact",
      "navbar_helpline": "Support Center",
      "navbar_dashboard": "My Dashboard",
      "navbar_logout": "Sign Out",
      "navbar_login_btn": "Log In",
      "navbar_signup_btn": "Sign Up",

      // --- Hero Section ---
      "hero_headline_prefix": "Trade Skills, Build",
      "hero_subtext": "The most trusted community marketplace for trading skills and services in Pakistan.",
      "hero_offer_skill_btn": "Offer a Skill",
      "hero_find_skill_btn": "Find a Skill",

      // --- How It Works ---
      "how_it_works_title": "How It Works",
      "how_it_works_subtitle": "Three simple steps to start trading your skills.",
      "step1_title": "Create Profile",
      "step1_description": "Sign up, verify your identity, and build your portfolio.",
      "step2_title": "Search or Offer",
      "step2_description": "Browse available skills or list your own services.",
      "step3_title": "Connect & Trade",
      "step3_description": "Chat, agree on terms, and swap skills securely.",

      // --- Featured Skills ---
      "featured_skills_title": "Featured Skills",
      "view_all_link": "View All",
      "view_details_link": "View Details",

      // --- Women's Zone ---
      "women_only_zone_tag": "Women Only Zone",
      "women_zone_description": "A safe, secure, and exclusive environment for women to trade skills comfortably.",
      "women_zone_button": "Enter Zone For",

      // --- Testimonials ---
      "testimonials_title": "What Our Community Says",

      // --- Login Page ---
      "login_welcome_back": "Welcome Back!",
      "login_access_account": "Access your account to manage skills and requests.",
      "login_credential_label": "Email, Username, or CNIC",
      "login_credential_placeholder": "Enter email, username, or CNIC",
      "login_password_placeholder": "Enter your password",
      "login_forgot_password": "Forgot Password?",
      "login_logging_in": "Logging in...",
      "login_no_account_prompt": "Don't have an account?",
      "login_success_title": "Welcome!",
      "login_success_message": "Login successful. Redirecting...",
      "login_unexpected_error": "Login failed. Please check your credentials.",

      // --- Signup Page ---
      "signup_join_gadd_kaam": "Join Gadd Kaam",
      "signup_start_offering_finding": "Start offering your skills or finding the right help today.",
      "signup_firstName_label": "First Name",
      "signup_firstName_placeholder": "Enter your first name",
      "signup_lastName_label": "Last Name",
      "signup_lastName_placeholder": "Enter your last name",
      "signup_profilePicture_label": "Profile Picture",
      "signup_username_label": "Username",
      "signup_username_placeholder": "Choose a username",
      "signup_phoneNumber_label": "Phone Number",
      "signup_email_label": "Email Address",
      "signup_dateOfBirth_label": "Date of Birth",
      "signup_cnicNumber_label": "CNIC Number",
      "signup_gender_label": "Gender",
      "signup_gender_male": "Male",
      "signup_gender_female": "Female",
      "signup_cnicFrontPic_label": "CNIC Front Picture",
      "signup_cnicBackPic_label": "CNIC Back Picture",
      "signup_password_label": "Password",
      "signup_confirmPassword_label": "Confirm Password",
      "signup_creating_account": "Creating Account...",
      "signup_create_account_btn": "Create Account",
      "signup_already_have_account": "Already have an account?",
      "signup_login_link": "Log In",
      "signup_error_passwords_mismatch": "Passwords do not match.",
      "signup_error_gender_required": "Please select a gender.",
      "signup_success_message": "Account created successfully! Redirecting...",
      "signup_success_modal_title": "Success",
      "signup_unexpected_error": "An unexpected error occurred. Please try again.",

          // --- Login Page Translations ---
          "login_welcome_back": "Welcome Back!",
          "login_access_account": "Log in to access your account and start swapping skills.",
          "login_credential_label": "Email, Username, or CNIC",
          "login_credential_placeholder": "Enter your credentials",
          "login_password_placeholder": "Enter your password",
          "login_forgot_password": "Forgot password?",
          "login_logging_in": "Logging In...",
          "login_no_account_prompt": "Don't have an account?",
          "login_success_message": "You have successfully logged in!",
          "login_unexpected_error": "An unexpected error occurred during login. Please try again.",
          "login_success_title": "Login Successful!",

          // --- Signup Page Translations ---
          "signup_join_gadd_kaam": "Join Gadd Kaam",
          "signup_start_offering_finding": "Create an account to start offering and finding skills in your community.",
          "signup_firstName_label": "First Name",
          "signup_firstName_placeholder": "Your first name",
          "signup_lastName_label": "LastName",
          "signup_lastName_placeholder": "Your last name",
          "signup_profilePicture_label": "Profile Picture",
          "signup_no_file_chosen": "No file selected.",
          "signup_username_label": "Username",
          "signup_username_placeholder": "Choose a username",
          "signup_phoneNumber_label": "Phone Number",
          "signup_email_label": "Email",
          "signup_dateOfBirth_label": "Date of Birth",
          "signup_cnicNumber_label": "CNIC Number",
          "signup_cnicNumber_placeholder": "e.g., 12345-1234567-1",
          "signup_cnicFrontPic_label": "CNIC Front Picture",
          "signup_cnicBackPic_label": "CNIC Back Picture",
          "signup_password_label": "Password",
          "signup_confirmPassword_label": "Confirm Password",
          "signup_create_account_btn": "Create Account",
          "signup_already_have_account": "Already have an account?",
          "signup_login_link": "Log In",
          "signup_success_message": "Account has been successfully created! Please log in.",
          "signup_error_gender_required": "Please select your gender.",
          "signup_unexpected_error": "An unexpected error occurred during signup.",
          "signup_gender_label": "Choose Male or Female",
          "signup_gender_male": "Male",
          "signup_gender_female": "Female",
          "signup_creating_account": "Creating Account...",
          "signup_success_modal_title": "Account Created!",


          // Chatbot Translations
          "chatbot_welcome_message": "Welcome to Gadd Kaam – SkillSwap Pakistan! 🤝\nEmpowering communities by connecting skills and opportunities.\nHow can I assist you today in Sindhi or Urdu? Ask me anything about our Marketplace, Women-Only Zone, posting skills, or support like FAQs and dispute resolution.",
          "chatbot_dummy_response": "I'm a simple AI assistant for now. How else can I help with information about Gadd Kaam?",
          "chatbot_input_placeholder": "Type your message here...",

          // Helpline Popup
          "helpline_popup_title": "Gadd Kaam Helpline",
          "helpline_number": "📞 +92-300-1234567",
          "helpline_note": "Available 24/7 for support.",

          // Logout Confirmation
          "logout_confirm_title": "Confirm Logout",
          "logout_confirm_message": "Are you sure you want to log out?",
          "logout_cancel_btn": "No, Cancel",
          "logout_confirm_btn": "Yes, Log Out",
        },
      },
      ur: {
        translation: {
          // General Utility (Urdu)
          "dark_mode_toggle": "ڈارک موڈ ٹوگل کریں",
          "change_language": "زبان تبدیل کریں",
          "call_helpline": "ہیلپ لائن پر کال کریں",
          "by_label": "پاران",
          "remotely_label": "دور سے",
          "anonymous_label": "گمنام",
          "women_only_zone_tag": "خواتین کا زون",
          "not_specified": "تفصیل نہیں دی گئی",
          "ok": "ٹھیک ہے",
          "all_rights_reserved": "تمام حقوق محفوظ ہیں۔",
          "confirm": "تصدیق کریں",
          
          // Request Modal (Urdu Fixes)
          "specify_skill_wanted_label": "وہ مہارت بتائیں جو آپ ان سے چاہتے ہیں:",
          "request_skill_placeholder": "مثال کے طور پر، مجھے ویب ڈیزائن کے بدلے ری ایکٹ ڈاٹ جے ایس ٹیوٹرنگ میں مدد کی ضرورت ہے۔",
          "work_can_be_remote_label": "کیا یہ کام دور سے (آن لائن) کیا جا سکتا ہے؟",
          "location_label": "مقام",
          "enter_location_placeholder": "مقام درج کریں...",
          "send_request_btn": "درخواست بھیجیں",
          "sending_request_btn": "بھیج رہا ہے...",
          "initial_request_message": "ہیلو، میں مہارت کے تبادلے کی درخواست کرنا چاہتا ہوں: {{skill}}",
          "request_sent_success_title": "درخواست بھیجی گئی!",
          "request_sent_success_message": "درخواست کامیابی سے بھیجی گئی!",
          "request_sent_error_title": "درخواست ناکام!",
          "request_sent_error_message": "درخواست بھیجنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "please_specify_skill_error": "براہ کرم اس مہارت کی وضاحت کریں جو آپ بدلے میں چاہتے ہیں۔",
          "location_required_non_remote_error": "غیر ریموٹ درخواستوں کے لیے مقام ضروری ہے۔",
          "failed_to_send_request_error": "درخواست بھیجنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "access_denied_female_only": "رسائی سے انکار: یہ علاقہ صرف خواتین صارفین کے لیے ہے۔",
          "failed_to_load_women_only_skills_error": "صرف خواتین کی مہارتیں لوڈ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "failed_to_load_marketplace_skills_error": "مارکیٹ پلیس کی مہارتیں لوڈ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",

          // Received Requests Page (Urdu)
          "offered_by": "پیش کردہ از",
          "women-only-banner":"خواتین کے لیے محفوظ اور تصدیق شدہ جگہ",
          "women_only_zone_banner_text":"خواتین کے لیے محفوظ اور تصدیق شدہ جگہ",
          "received_requests_page_title": "موصول شدہ درخواستیں",
          "received_requests_page_subtitle": "کمیونٹی کے دیگر اراکین سے مہارت کے تبادلے کی درخواستوں کا انتظام کریں۔",
          "no_requests_received": "آپ کو ابھی تک مہارت کی کوئی درخواست موصول نہیں ہوئی ہے۔",
          "requested_by": "درخواست کردہ از",
          "offered_skill_label_in_request": "پیش کردہ مہارت",
          "message_label": "پیغام",
          "date_received": "موصول ہونے کی تاریخ",
          "accept_btn": "قبول کریں",
          "decline_btn": "رد کریں",
          "requested_your_skill": "آپ کی مہارت کی درخواست کی گئی",
          "sender_offers_in_return": "بھیجنے والا بدلے میں پیش کرتا ہے",
          "cancel_btn": "منسوخ کریں",
          "request_accepted_by": "{{username}} نے درخواست قبول کر لی! 🎉",
          "contact_them_to_coordinate": "اب آپ ان سے اپنی مہارت کے تبادلے کو مربوط کرنے کے لیے رابطہ کر سکتے ہیں۔",
          "contact_details_heading": "رابطے کی تفصیلات:",
          "name_label": "نام",
          "offer_a_skill_title": "ہنر پیش کریں",
"offer_a_skill_subtitle": "کمیونٹی کے ساتھ اپنی مہارت شیئر کریں",
"fill_all_required_fields": "براہ کرم تمام مطلوبہ خانے پُر کریں۔",
"cover_photo_label": "کور فوٹو",
"click_to_upload": "تصویر اپ لوڈ کرنے کے لیے کلک کریں",
"skill_title_label": "ہنر کا عنوان (مثلاً ویب ڈویلپمنٹ، پلمبنگ)",
"skill_title_placeholder": "کوما کے ذریعے ہنر درج کریں...",
"description_label": "تفصیل",
"description_placeholder": "بیان کریں کہ آپ کیا کر سکتے ہیں...",
"skills_wanted_label": "بدلے میں مطلوبہ ہنر (اختیاری)",
"skills_wanted_placeholder": "مثلاً گرافک ڈیزائن، باغبانی...",
"location_label": "مقام",
"location_placeholder": "شہر، علاقہ",
"remote_work_label": "ریموٹ کام",
"remote_work_desc": "سروس آن لائن فراہم کی جا سکتی ہے",
"post_anonymously_label": "گمنام پوسٹ کریں",
"post_anonymously_desc": "کارڈ پر اپنا نام چھپائیں",
"women_only_zone_label": "خواتین زون",
"women_only_zone_desc": "صرف خواتین صارفین کو نظر آئے گا",
"post_skill_offer_btn": "ہنر کی پیشکش پوسٹ کریں",
"live_preview_title": "لائیو پیش نظارہ",
"live_preview_desc": "آپ کا کارڈ مارکیٹ پلیس میں ایسا نظر آئے گا۔",
"your_skill_title": "آپ کے ہنر کا عنوان",
"anonymous_user": "گمنام صارف",
"skill_posted_success_title": "ہنر پوسٹ ہو گیا!",
"skill_posted_success_message": "آپ کے ہنر کی پیشکش کامیابی کے ساتھ مارکیٹ پلیس میں پوسٹ کر دی گئی ہے۔",
"offer_publish_error_message": "ہنر شائع کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "phone_label": "فون",
          "failed_to_load_requests_error": "درخواستیں لوڈ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "request_accepted_notification": "درخواست قبول ہو گئی! صارف کو مطلع کر دیا گیا ہے۔",
          "failed_to_accept_request_error": "درخواست قبول کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "request_cancelled_notification": "درخواست منسوخ کر دی گئی۔",
          "failed_to_cancel_request_error": "درخواست منسوخ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "pending_requests_section_title": "زیر التواء درخواستیں",
          "accepted_requests_section_title": "منظور شدہ درخواستیں",
          "no_new_requests_message_p1": "آپ کے پاس فی الحال کوئی نئی مہارت کی درخواستیں یا منظور شدہ تبادلے نہیں ہیں۔",
          "no_new_requests_message_p2": "جب کوئی آپ کی مہارت میں سے کسی ایک کی درخواست کرے گا تو وہ یہاں ظاہر ہو گا۔",
          "your_request_accepted_by": "آپ کی درخواست قبول کر لی گئی",
          "message_btn": "پیغام",

          // Navbar (Urdu)
          "navbar_home": "ہوم",
          "navbar_about_us": "ہمارے بارے میں",
          "navbar_women_zone": "خواتین کا زون",
          "navbar_contact": "رابطہ کریں",
          "navbar_login_btn": "لاگ ان کریں",
          "navbar_signup_btn": "سائن اپ کریں",
          "navbar_logout": "لاگ آؤٹ",
          "navbar_dashboard": "ڈیش بورڈ",
          "navbar_my_profile": "میرا پروفائل",
          "navbar_my_skills": "میری مہارتیں",
          "navbar_messages": "پیغامات",
          "navbar_marketplace": "مارکیٹ پلیس",
          "navbar_reviews": "جائزے",
          "navbar_notifications": "اطلاعات",
          "navbar_helpline": "ہیلپ لائن",

          // Hero Section (Urdu)
          "hero_headline": "مہارتوں کا تبادلہ، مستقبل کی تعمیر۔",
          "hero_subtext": "گڈ کام – اسکل سویپ پاکستان ایک ایسی کمیونٹی ہے جہاں آپ اپنی صلاحیتوں کا تبادلہ اپنی ضرورت کی مدد کے لیے کر سکتے ہیں، بغیر پیسوں کے۔",
          "hero_offer_skill_btn": "مہارت پیش کریں",
          "hero_find_skill_btn": "مہارت تلاش کریں",
          "hero_title": "مقامی ہنر سے جڑیں",
          "hero_subtitle": "پاکستان میں مقامی خدمات تلاش کرنے اور پیش کرنے کے لیے آپ کا ون اسٹاپ منزل۔",
          "hero_join_now": "ابھی شامل ہوں",
          "hero_find_service": "خدمت تلاش کریں",
          "hero_find_service_desc": "اپنے علاقے میں ہنر مند پیشہ ور افراد کی طرف سے پیش کردہ خدمات کی وسیع رینج کو براؤز کریں۔",
          "hero_offer_skills": "اپنی مہارتیں پیش کریں",
          "hero_offer_skills_desc": "ایک پروفائل بنائیں اور کمیونٹی کو اپنی خدمات پیش کرکے کمانا شروع کریں۔",
          "hero_secure_reliable": "محفوظ اور قابل اعتماد",
          "hero_secure_reliable_desc": "ہم تمام لین دین اور مواصلات کے لیے ایک محفوظ پلیٹ فارم فراہم کرتے ہیں۔",

          // How It Works Section (Urdu)
          "how_it_works_title": "یہ کیسے کام کرتا ہے",
          "how_it_works_subtitle": "ہماری کمیونٹی میں شامل ہونا آسان ہے۔ مہارتوں کا تبادلہ شروع کرنے کے لیے ان آسان اقدامات پر عمل کریں۔",
          "step1_title": "1. پروفائل بنائیں",
          "step1_description": "سائن اپ کریں اور اپنی پیش کردہ مہارتوں کی فہرست بنائیں۔ اعتماد پیدا کرنے کے لیے تصدیق کروائیں۔",
          "step2_title": "2. تلاش کریں اور تبادلہ کریں",
          "step2_description": "اپنی مطلوبہ مہارتیں براؤز کریں، یا درخواست پوسٹ کریں۔ تبادلے کا انتظام کرنے کے لیے دوسروں سے رابطہ کریں۔",
          "step3_title": "3. درجہ بندی کریں اور کمائیں",
          "step3_description": "تبادلہ مکمل کریں، رائے دیں، اور اپنے تعاون کے لیے اسکل پوائنٹس حاصل کریں۔",

          // Featured Skills Section (Urdu)
          "quick_actions": "فوری اقدامات",
          "featured_skills_title": "نمایاں مہارتیں",
          "view_all_link": "تمام دیکھیں →",
          "view_details_link": "تفصیلات دیکھیں →",

          // Testimonials Section (Urdu)
          "testimonials_title": "ہماری کمیونٹی کیا کہتی ہے",
          "testimonial1_quote": "میں نے اپنے پڑوسی کے واٹر پمپ کو ٹھیک کیا، اور بدلے میں، ان کی بیوی نے میری بیٹی کو کڑھائی سکھائی۔ گڈ کام – اسکل سویپ نے یہ ممکن بنایا۔ یہ ہمارے گاؤں کے لیے ایک نعمت ہے۔",
          "testimonial1_author_name": "اقبال حسین",
          "testimonial1_author_details": "میکینک، پنجاب",
          "testimonial2_quote": "ایک عورت کے طور پر، کام تلاش کرنا ہمیشہ آسان نہیں ہوتا۔ خواتین کے لیے مخصوص زون کے ذریعے، مجھے اپنی سلائی کی مہارت پیش کرنے اور ایک اور عورت سے اکاؤنٹنگ سیکھنے کے لیے ایک محفوظ جگہ ملی۔",
          "testimonial2_author_name": "سمینہ اختر",
          "testimonial2_author_details": "ہوم شیف، سندھ",

          // Women's Zone Section (Urdu)
          "women_zone_title": "خواتین کے لیے ایک محفوظ جگہ",
          "women_zone_description": "ہماری خواتین کے لیے مخصوص اسکل زون خواتین کو اعتماد کے ساتھ جوڑنے، سیکھنے اور مہارتوں کا تبادلہ کرنے کے لیے ایک محفوظ اور معاون ماحول فراہم کرتا ہے۔",
          "women_zone_button": "خواتین کے زون کو دریافت کریں",

          // Footer (Urdu)
          "footer_tagline": "مہارتوں کو جوڑ کر، بغیر پیسوں کے، کمیونٹیز کو بااختیار بنانا۔",
          "footer_quick_links": "فوری لنکس",
          "footer_support": "سپورٹ",
          "footer_follow_us": "ہمیں فالو کریں",
          "footer_copyright": "گڈ کام – اسکل سویپ پاکستان۔ تمام حقوق محفوظ ہیں۔",
          "footer_privacy_policy": "پرائیویسی پالیسی",
          "footer_terms_of_service": "سروس کی شرائط",
          "Empowering_communities_by_connecting_skills_cash_free": "مہارتوں کو نقد کے بغیر جوڑ کر کمیونٹیز کو بااختیار بنانا۔",
          "post_a_skill": "ایک مہارت پوسٹ کریں",
          "faq_link": "اکثر پوچھے گئے سوالات",
          "dispute_resolution_link": "تنازعہ کا حل",


          // Language names for display (Urdu)
          "lang_en": "انگریزی",
          "lang_ur": "اردو",
          "lang_sd": "سنڌي",

          // --- Dashboard Translations (Urdu) ---
          "dashboard_welcome_heading": "خوش آمدید، {{username}}!",
          "dashboard_sub_heading": "یہاں آپ کی اسکل سویپ سرگرمی کا ایک فوری جائزہ ہے۔",
          "skills_offered_title": "پیش کردہ مہارتیں",
          "skills_offered_detail": "شروع کرنے کے لیے ایک مہارت پوسٹ کریں!",
          "skills_received_title": "حاصل کردہ مہارتیں",
          "skills_received_detail": "آج ہی نئی چیزیں سیکھنا شروع کریں!",
          "unread_messages_title": "نہ پڑھے گئے پیغامات",
          "unread_messages_detail": "ابھی تک کوئی نیا پیغام نہیں ہے۔",
          "find_skill_title": "ایک مہارت تلاش کریں",
          "find_skill_description": "اپنی کمیونٹی میں نئی مہارتیں دریافت کرنے اور باصلاحیت لوگوں سے جڑنے کے لیے مارکیٹ پلیس کو دریافت کریں۔",
          "browse_marketplace_btn": "مارکیٹ پلیس براؤز کریں",
          "offer_skill_title_card": "ایک مہارت پیش کریں",
          "offer_skill_description_card": "اپنی مہارت کمیونٹی کے ساتھ شیئر کریں۔ ایک ایسی مہارت پوسٹ کریں جو آپ سکھا سکتے ہیں یا کوئی ایسی خدمت جو آپ فراہم کر سکتے ہیں۔",
          "post_new_skill_btn": "نئی مہارت پوسٹ کریں",

          // --- Profile Page Translations (Urdu) ---
          "profile_page_title": "میرا پروفائل",
          "profile_update_prompt": "اپنی تصویر اور ذاتی تفصیلات یہاں اپ ڈیٹ کریں۔",
          "change_picture_btn": "تصویر تبدیل کریں",
          "full_name_label": "پورا نام",
          "email_address_label": "ای میل ایڈریس",
          "phone_number_label": "فون نمبر",
          "location_label": "مقام",
          "about_me_label": "میرے بارے میں",
          "discard_changes_btn": "تبدیلیاں مسترد کریں",
          "save_changes_btn": "تبدیلیاں محفوظ کریں",
          "my_badges_title": "میرے بیجز",

          // --- Offer Skill Page Translations (Urdu) ---
          "offer_skill_title": "ایک نئی مہارت پیش کریں",
          "offer_skill_subtitle": "اپنی مہارتیں شیئر کریں اور اپنی کمیونٹی میں دوسروں سے جڑیں!",
          "step1_offer_skill": "مرحلہ 1: آپ کیا پیش کر سکتے ہیں؟",
          "step1_offer_skill_desc": "اپنی مہارت کا اشتراک کریں اور کچھ نیا سیکھتے ہوئے دوسروں کی مدد کریں! نیچے دی گئی فہرست سے 3 تک مہارتیں منتخب کریں جن میں آپ پراعتماد ہیں، یا اپنی تلاش کریں۔",
          "step1_offer_skill_label": "آپ کون سی اعلیٰ مہارتیں دوسروں کو پیش کرنا چاہیں گے؟",
          "step1_offer_skill_placeholder": "پیش کرنے کے لیے مہارتیں تلاش کریں...",
          "step2_offer_skill": "مرحلہ 2: مزید تفصیلات شامل کریں",
          "step2_offer_skill_desc": "اپنی فہرست کو نمایاں کرنے کے لیے ایک اختیاری تصویر اور تفصیل شامل کریں۔ لوگوں کو آپ سے جڑنے میں مدد کے لیے اپنا مقام اور رابطے کی تفصیلات فراہم کریں۔",
          "step2_photo_label": "ایک تصویر اپ لوڈ کریں (اختیاری)",
          "step2_description_label": "تفصیل",
          "step2_description_placeholder": "آپ جو پیش کر رہے ہیں اس کی مزید تفصیل سے وضاحت کریں...",
          "step2_location_label": "مقام",
          "step2_location_placeholder": "مثلاً، لاہور، پاکستان",
          "step2_go_anonymous_switch": "گمنام رہیں",
          "step2_remotely_switch": "دور سے دستیاب",
          "step2_women_zone_switch": "خواتین کے لیے مخصوص زون میں شیئر کریں",
          "step3_offer_skill": "مرحلہ 3: بدلے میں آپ کیا چاہتے ہیں؟",
          "step3_offer_skill_desc": "ہمیں بتائیں کہ آپ کن مہارتوں کا تبادلہ کرنا چاہتے ہیں اور نئے مواقع دریافت کریں! فہرست سے 3 تک مہارتیں منتخب کریں جو آپ سیکھنا یا بہتر کرنا چاہتے ہیں۔",
          "step3_offer_skill_label": "آپ کن نئی مہارتوں کا تبادلہ کرنے کے لیے پرجوش ہیں؟",
          "step3_offer_skill_placeholder": "سیکھنے کے لیے مہارتیں تلاش کریں...",
          "step4_offer_skill": "مرحلہ 4: جائزہ لیں اور شائع کریں",
          "step4_offer_skill_desc": "براہ کرم نیچے دی گئی تمام تفصیلات کا جائزہ لیں۔ اگر سب کچھ ٹھیک ہے تو، اپنی پیشکش کو مارکیٹ پلیس پر شائع کریں۔",
          "step4_review_message": "تصدیق کرکے، آپ ہماری سروس کی شرائط اور رازداری کی پالیسی سے اتفاق کرتے ہیں۔",
          "step4_confirm_publish_btn": "تصدیق کریں اور شائع کریں",
          "go_back_btn": "واپس",
          "next_btn": "آگے",

          // --- My Skills Page Translations (Urdu) ---
          "my_skills_page_title": "میری پیش کردہ مہارتیں",
          "my_skills_page_subtitle": "اپنی فعال مہارت کی پیشکشوں کا انتظام کریں اور ان کی کارکردگی کو ٹریک کریں۔",
          "no_skills_offered": "آپ نے ابھی تک کوئی مہارت پیش نہیں کی ہے۔ شروع کرنے کے لیے ایک پوسٹ کریں!",
          "view_full_details_btn": "مکمل تفصیلات دیکھیں",
          "delete_offer_btn": "پیشکش حذف کریں",
          "offer_skill_label": "پیش کردہ مہارت",
          "swap_skill_label": "مطلوبہ مہارت",
          "description_label": "تفصیل",
          "skill_not_specified": "واضح نہیں کیا گیا",
          "yes": "ہاں",
          "no": "نہیں",
          "failed_to_load_my_skills_error": "آپ کی مہارتیں لوڈ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "skill_offer_deleted_success": "مہارت کی پیشکش کامیابی سے حذف ہو گئی!",
          "failed_to_delete_skill_offer_error": "مہارت کی پیشکش حذف کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "delete_confirm_title": "تصدیق حذف کریں",
          "delete_confirm_message": "کیا آپ واقعی اس مہارت کی پیشکش کو حذف کرنا چاہتے ہیں؟ یہ کارروائی کالعدم نہیں کی جا سکتی۔",

          // --- Marketplace Page Translations (Urdu) ---
          "marketplace_page_title": "مہارت مارکیٹ پلیس",
          "marketplace_page_subtitle": "اپنی کمیونٹی میں دوسروں کی طرف سے پیش کردہ مہارتیں دریافت کریں۔",
          "no_skills_available": "اس وقت مارکیٹ پلیس میں کوئی مہارت دستیاب نہیں ہے۔ بعد میں دوبارہ چیک کریں!",
          "request_btn": "درخواست",
          "no_skills_available_from_others": "ابھی تک دیگر صارفین سے کوئی ہنر دستیاب نہیں ہے۔",
          "no_skills_match_filters": "کوئی ہنر آپ کے فلٹرز سے مماثل نہیں ہے۔",
          "search_skills_placeholder": "ہنر تلاش کریں...",
          "no_categories_available": "کوئی زمرہ دستیاب نہیں ہے۔",
          "clear_all_filters": "تمام فلٹرز صاف کریں",

          // --- Women Only Zone Page Translations (Urdu) ---
          "women_only_zone_page_title": "خواتین کے لیے مخصوص مہارت زون",
          "women_only_zone_page_subtitle": "خواتین کے لیے مہارتیں محفوظ طریقے سے شیئر کرنے اور تبادلہ کرنے کے لیے ایک مخصوص جگہ۔",
          "no_women_zone_skills_available": "اس وقت خواتین کے لیے مخصوص زون میں کوئی مہارت دستیاب نہیں ہے۔ بعد میں دوبارہ چیک کریں!",

          // --- Messages Page Translations (Urdu) ---
          "messages_page_title": "میرے پیغامات",
          "messages_page_subtitle": "دوسرے صارفین کے ساتھ اپنی بات چیت دیکھیں اور ان کا انتظام کریں۔",
          "no_messages_yet": "آپ کے پاس ابھی کوئی پیغام نہیں ہے۔",
          "search_messages_placeholder": "پیغامات تلاش کریں...",
          "no_messages_found": "کوئی گفتگو نہیں ملی۔",
          "select_conversation_message": "ایک گفتگو کا انتخاب کریں",
          "choose_chat_to_start": "گفتگو شروع کرنے کے لیے بائیں جانب سے ایک چیٹ منتخب کریں۔",
          "chat_with_user_placeholder": "چیٹ",
          "skill_received_btn": "مہارت موصول ہوئی",
          "report_btn": "رپورٹ کریں",
          "type_your_message_placeholder": "اپنا پیغام لکھیں...",
          "chat_initial_greeting": "ہیلو! میں آج آپ کی کیسے مدد کر سکتا ہوں؟",
          "chat_how_can_i_help": "میں تیار ہوں جب آپ ہوں!",
          "chat_user_response": "بہت اچھا، میں اس کا انتظار کر رہا ہوں!",
          "chat_message_ali": "ضرور، کل ملتے ہیں۔",
          "chat_message_fatima": "مجھے مہارت موصول ہو گئی!",
          "chat_message_usman": "نئی درخواست کے لیے ابتدائی پیغام۔",
          "chat_message_ayesha": "تبادلہ مکمل ہو گیا۔ براہ کرم ایک جائزہ چھوڑیں!",
          "exchange_completed_chat_view_only": "یہ تبادلہ مکمل ہو گیا ہے۔ اب آپ پیغامات نہیں بھیج سکتے۔",
          "exchange_completed_no_chat": "یہ تبادلہ مکمل ہو گیا ہے۔",
          "exchange_completed_chat_summary": "تبادلہ مکمل ہو گیا۔ براہ کرم ایک جائزہ چھوڑیں!",
          "confirm_skill_received_title": "مہارت موصول ہونے کی تصدیق کریں؟",
          "confirm_skill_received_message": "کیا آپ کو واقعی مہارت موصول ہوئی؟ یہ کارروائی کالعدم نہیں کی جا سکتی اور جائزہ کے عمل کی طرف لے جائے گی۔",
          "error_confirming_skill_received": "مہارت موصول ہونے کی تصدیق کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "error_confirming_skill_received_generic": "مہارت موصول ہونے کی تصدیق کرنے میں ناکامی۔ ایک خامی پیش آگئی۔",
          "error_no_request_id": "مہارت کی تصدیق نہیں ہو سکی۔ درخواست ID غائب ہے۔",
          "error_title": "خامی",
          "your_confirmation_pending": "آپ کی تصدیق زیر التوا ہے",
          "partner_confirmation_pending": "پارٹنر کی تصدیق زیر التوا ہے",
          "exchange_completed_label": "تبادلہ مکمل ہو گیا",


          // --- Reviews Page Translations (Urdu) ---
          "reviews_page_title": "جائزے",
          "reviews_page_subtitle": "مکمل شدہ مہارت کے تبادلوں پر اپنا رائے دیں اور موصول ہونے والے جائزے دیکھیں۔",
          "no_reviews_yet": "آپ کو ابھی تک کوئی جائزہ موصول نہیں ہوا ہے۔",
          "review_submitted_title": "جائزہ جمع ہو گیا!",
          "review_submitted_message": "آپ کی رائے کا شکریہ۔ آپ کا جائزہ کمیونٹی میں اعتماد پیدا کرنے میں مدد کرتا ہے۔",
          "back_to_dashboard_btn": "ڈیش بورڈ پر واپس",
          "rate_skill_exchange_with": "آپ کی مہارت کا {{username}} کے ساتھ تبادلہ کی درجہ بندی کریں",
          "your_review_label": "آپ کا جائزہ",
          "review_placeholder": "یہاں اپنا جائزہ لکھیں...",
          "endorse_skills_label": "{{username}} کے لیے مہارتوں کی توثیق کریں",
          "endorse_btn": "توثیق کریں",
          "submit_review_btn": "جائزہ جمع کروائیں",
          "reviews_received_tab": "موصول شدہ جائزے",
          "write_a_review_tab": "جائزہ لکھیں",
          "no_received_reviews_yet": "آپ کو ابھی تک کوئی جائزہ موصول نہیں ہوا ہے۔",
          "no_pending_reviews": "کوئی زیر التوا جائزہ نہیں ہے۔ آپ نے تمام مکمل شدہ تبادلوں کا جائزہ لے لیا ہے!",
          "review_for_exchange_with": "{{username}} کے ساتھ تبادلے کا جائزہ",
          "skills_involved": "شامل مہارتیں:",
          "skill_offered_by_them": "ان کی طرف سے پیش کردہ مہارت:",
          "skill_you_requested": "آپ نے درخواست کی مہارت:",
          "rating_label": "درجہ بندی:",
          "by_reviewer_name": "بذریعہ {{username}}",
          "failed_to_submit_review": "جائزہ جمع کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
          "failed_to_load_received_reviews": "موصول شدہ جائزے لوڈ کرنے میں ناکامی۔",
          "failed_to_load_pending_reviews": "زیر التوا جائزے لوڈ کرنے میں ناکامی۔",
          "review_submission_status": "جائزہ جمع کرانے کی حیثیت",
          "review_submitted_success": "آپ کا جائزہ کامیابی سے جمع کر دیا گیا ہے!",
          "failed_to_submit_review_error": "جائزہ جمع کرنے میں ناکام۔ براہ کرم دوبارہ کوشش کریں۔",
          "please_provide_rating": "براہ کرم درجہ بندی فراہم کریں۔",
          "please_provide_review_comment": "براہ کرم ایک جائزہ تبصرہ فراہم کریں۔",
          "your_comments_label": "آپ کے تبصرے",
          "review_comment_placeholder": "اپنا تجربہ شیئر کریں...",
          "rate_exchange_label": "اس تبادلے کی درجہ بندی کریں",
          "write_review_for_label": "{{username}} کے لیے جائزہ لکھیں",
          "no_received_reviews": "ابھی تک کوئی جائزہ موصول نہیں ہوا۔",
          "received_reviews_tab": "موصول شدہ جائزے",
          "endorse_skills_optional": "مہارت کی توثیق (اختیاری)",


          // --- Login Page Translations (Urdu) ---
          "login_welcome_back": "خوش آمدید!",
          "login_access_account": "اپنے اکاؤنٹ تک رسائی حاصل کرنے اور مہارتوں کا تبادلہ شروع کرنے کے لیے لاگ ان کریں۔",
          "login_credential_label": "ای میل، صارف نام، یا شناختی کارڈ",
          "login_credential_placeholder": "اپنی اسناد درج کریں",
          "login_password_placeholder": "اپنا پاس ورڈ درج کریں",
          "login_forgot_password": "پاس ورڈ بھول گئے؟",
          "login_logging_in": "لاگ ان ہو رہا ہے...",
          "login_no_account_prompt": "اکاؤنٹ نہیں ہے؟",
          "login_success_message": "آپ کامیابی سے لاگ ان ہو گئے ہیں!",
          "login_unexpected_error": "لاگ ان کے دوران ایک غیر متوقع خرابی پیش آئی۔ براہ کرم دوبارہ کوشش کریں۔",
          "login_success_title": "لاگ ان کامیاب!",
          "app_name": "گڈ کام",
      
      // Navbar
      "navbar_home": "ہوم",
      "navbar_marketplace": "مارکیٹ پلیس",
      "navbar_women_zone": "خواتین زون",
      "navbar_about_us": "ہمارے بارے میں",
      "navbar_contact": "رابطہ کریں",
      "navbar_helpline": "سپورٹ سینٹر",
      "navbar_dashboard": "میرا ڈیش بورڈ",
      "navbar_logout": "لاگ آؤٹ",
      "navbar_login_btn": "لاگ ان",
      "navbar_signup_btn": "سائن اپ",

      // Hero
      "hero_headline_prefix": "مہارت کا تبادلہ، تعمیر کریں",
      "hero_subtext": "مہارتوں اور خدمات کے تبادلے کے لیے پاکستان کی سب سے قابل اعتماد کمیونٹی۔",
      "hero_offer_skill_btn": "مہارت پیش کریں",
      "hero_find_skill_btn": "مہارت تلاش کریں",

      // How It Works
      "how_it_works_title": "یہ کیسے کام کرتا ہے",
      "how_it_works_subtitle": "شروع کرنے کے لیے تین آسان اقدامات۔",
      "step1_title": "پروفائل بنائیں",
      "step1_description": "سائن اپ کریں، اپنی شناخت کی تصدیق کریں اور اپنا پورٹ فولیو بنائیں۔",
      "step2_title": "تلاش کریں یا پیش کریں",
      "step2_description": "دستیاب مہارتیں براؤز کریں یا اپنی خدمات کی فہرست بنائیں۔",
      "step3_title": "رابطہ اور تجارت",
      "step3_description": "بات چیت کریں، شرائط پر اتفاق کریں، اور محفوظ طریقے سے مہارت کا تبادلہ کریں۔",

      // Featured Skills
      "featured_skills_title": "نمایاں مہارتیں",
      "view_all_link": "سب دیکھیں",
      "view_details_link": "تفصیلات دیکھیں",

      // Women's Zone
      "women_only_zone_tag": "صرف خواتین کے لیے",
      "women_zone_description": "خواتین کے لیے مہارتوں کے تبادلے کا ایک محفوظ اور پرسکون ماحول۔",
      "women_zone_button": "زون میں داخل ہوں",

      // Testimonials
      "testimonials_title": "ہماری کمیونٹی کیا کہتی ہے",

      // Login Page
      "login_welcome_back": "خوش آمدید!",
      "login_access_account": "مہارتوں اور درخواستوں کا انتظام کرنے کے لیے اپنے اکاؤنٹ تک رسائی حاصل کریں۔",
      "login_credential_label": "ای میل، صارف نام، یا شناختی کارڈ",
      "login_credential_placeholder": "ای میل، صارف نام، یا شناختی کارڈ درج کریں",
      "login_password_placeholder": "اپنا پاس ورڈ درج کریں",
      "login_forgot_password": "پاس ورڈ بھول گئے؟",
      "login_logging_in": "لاگ ان ہو رہا ہے...",
      "login_no_account_prompt": "اکاؤنٹ نہیں ہے؟",
      "login_success_title": "خوش آمدید!",
      "login_success_message": "لاگ ان کامیاب۔ ری ڈائریکٹ کیا جا رہا ہے...",
      "login_unexpected_error": "لاگ ان ناکام۔ براہ کرم اپنی معلومات چیک کریں۔",

      // Signup Page
      "signup_join_gadd_kaam": "گڈ کام میں شامل ہوں",
      "signup_start_offering_finding": "آج ہی اپنی مہارتیں پیش کرنا شروع کریں یا مدد تلاش کریں۔",
      "signup_firstName_label": "پہلا نام",
      "signup_firstName_placeholder": "اپنا پہلا نام درج کریں",
      "signup_lastName_label": "آخری نام",
      "signup_lastName_placeholder": "اپنا آخری نام درج کریں",
      "signup_profilePicture_label": "پروفائل تصویر",
      "signup_username_label": "صارف نام (Username)",
      "signup_username_placeholder": "کوئی صارف نام منتخب کریں",
      "signup_phoneNumber_label": "فون نمبر",
      "signup_email_label": "ای میل ایڈریس",
      "signup_dateOfBirth_label": "پیدائش کی تاریخ",
      "signup_cnicNumber_label": "شناختی کارڈ نمبر",
      "signup_gender_label": "صنف",
      "signup_gender_male": "مرد",
      "signup_gender_female": "عورت",
      "signup_cnicFrontPic_label": "شناختی کارڈ سامنے کی تصویر",
      "signup_cnicBackPic_label": "شناختی کارڈ پیچھے کی تصویر",
      "signup_password_label": "پاس ورڈ",
      "signup_confirmPassword_label": "پاس ورڈ کی تصدیق کریں",
      "signup_creating_account": "اکاؤنٹ بنایا جا رہا ہے...",
      "signup_create_account_btn": "اکاؤنٹ بنائیں",
      "signup_already_have_account": "پہلے سے اکاؤنٹ موجود ہے؟",
      "signup_login_link": "لاگ ان کریں",
      "signup_error_passwords_mismatch": "پاس ورڈ میچ نہیں کر رہے۔",
      "signup_error_gender_required": "براہ کرم صنف منتخب کریں۔",
      "signup_success_message": "اکاؤنٹ کامیابی سے بن گیا! ری ڈائریکٹ کیا جا رہا ہے...",
      "signup_success_modal_title": "کامیابی",
      "signup_unexpected_error": "ایک غیر متوقع خرابی پیش آئی۔ براہ کرم دوبارہ کوشش کریں۔",

          // --- Signup Page Translations (Urdu) ---
          "signup_join_gadd_kaam": "گڈ کام میں شامل ہوں",
          "signup_start_offering_finding": "اپنی کمیونٹی میں ہنر پیش کرنے اور تلاش کرنے کے لیے ایک اکاؤنٹ بنائیں۔",
          "signup_firstName_label": "پہلا نام",
          "signup_firstName_placeholder": "آپ کا پہلا نام",
          "signup_lastName_label": "آخری نام",
          "signup_lastName_placeholder": "آپ کا آخری نام",
          "signup_profilePicture_label": "پروفائل تصویر",
          "signup_no_file_chosen": "کوئی فائل منتخب نہیں کی گئی۔",
          "signup_username_label": "صارف نام",
          "signup_username_placeholder": "صارف نام منتخب کریں",
          "signup_phoneNumber_label": "فون نمبر",
          "signup_email_label": "ای میل",
          "signup_dateOfBirth_label": "تاریخ پیدائش",
          "signup_cnicNumber_label": "شناختی کارڈ نمبر",
          "signup_cnicNumber_placeholder": "مثال کے طور پر، 12345-1234567-1",
          "signup_cnicFrontPic_label": "شناختی کارڈ سامنے کی تصویر",
          "signup_cnicBackPic_label": "شناختی کارڈ پیچھے کی تصویر",
          "signup_password_label": "پاس ورڈ",
          "signup_confirmPassword_label": "پاس ورڈ کی تصدیق کریں",
          "signup_create_account_btn": "اکاؤنٹ بنائیں",
          "signup_already_have_account": "پہلے سے ہی اکاؤنٹ ہے؟",
          "signup_login_link": "لاگ ان کریں",
          "signup_success_message": "اکاؤنٹ کامیابی سے بن گیا! براہ کرم لاگ ان کریں۔",
          "signup_error_gender_required": "براہ کرم اپنی جنس منتخب کریں۔",
          "signup_unexpected_error": "سائن اپ کے دوران ایک غیر متوقع خرابی پیش آئی۔",
          "signup_gender_label": "مرد یا عورت منتخب کریں",
          "signup_gender_male": "مرد",
          "signup_gender_female": "عورت",
          "signup_creating_account": "اکاؤنٹ بنا رہا ہے...",
          "signup_success_modal_title": "اکاؤنٹ بن گیا!",
          // --- Admin & Report Features ---
      "navbar_admin_dashboard": "ایڈمن ڈیش بورڈ",
      "navbar_admin_users": "صارفین کا انتظام",
      "navbar_admin_skills": "ہنر کا انتظام",
      "navbar_admin_reports": "رپورٹس کا انتظام",

      "report_btn": "رپورٹ کریں",
      "report_user_title": "{{name}} کی رپورٹ کریں",
      "report_user_desc": "براہ کرم اس صارف کی رپورٹ کرنے کی وجہ منتخب کریں۔ ہماری ایڈمن ٹیم اس رپورٹ اور چیٹ کا جائزہ لے گی۔",
      "submit_report_btn": "رپورٹ جمع کرائیں",
      "report_submitted_success": "رپورٹ کامیابی کے ساتھ جمع کر دی گئی ہے۔ ہماری ٹیم جلد ہی اس کا جائزہ لے گی۔",
      "cancel_btn": "منسوخ کریں",

      // --- New Footer Links ---
      "footer_quick_links": "فوری روابط",
      "footer_support": "مدد",
      "footer_follow_us": "ہمیں فالو کریں",
      "faq_link": "عام سوالات",
      "dispute_resolution_link": "تنازعات کا حل",
      "footer_privacy_policy": "پرائیویسی پالیسی",
      "footer_terms_of_service": "سروس کی شرائط",


          // Chatbot Translations (Urdu)
          "chatbot_welcome_message": "گڈ کام – اسکل سویپ پاکستان میں خوش آمدید! 🤝\nمہارتوں اور مواقع کو جوڑ کر کمیونٹیز کو بااختیار بنانا۔\nمیں آج آپ کی سندھی یا اردو میں کیسے مدد کر سکتا ہوں؟ ہمارے مارکیٹ پلیس، خواتین کے زون، مہارتیں پوسٹ کرنے، یا سپورٹ جیسے سوالات اور تنازعات کے حل کے بارے میں کچھ بھی پوچھیں۔",
          "chatbot_dummy_response": "میں فی الحال ایک سادہ AI اسسٹنٹ ہوں۔ گڈ کام کے بارے میں مزید معلومات کے ساتھ میں میں آپ کی اور کیسے مدد کر سکتا ہوں؟",
          "chatbot_input_placeholder": "یہاں اپنا پیغام لکھیں...",

          // Helpline Popup (Urdu)
          "helpline_popup_title": "گڈ کام ہیلپ لائن",
          "helpline_number": "📞 923001234567+",
          "helpline_note": "مدد کے لیے 24/7 دستیاب ہے۔",

          // Logout Confirmation (Urdu)
          "logout_confirm_title": "لاگ آؤٹ کی تصدیق کریں",
          "logout_confirm_message": "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟",
          "logout_cancel_btn": "نہیں، منسوخ کریں",
          "logout_confirm_btn": "ہاں، لاگ آؤٹ کریں",
          
        },
      },
      sd: {
        translation: {
          // --- Admin & Report Features ---
      "navbar_admin_dashboard": "ايڊمن ڊيش بورڊ",
      "navbar_admin_users": "استعمال ڪندڙن جو انتظام",
      "navbar_admin_skills": "هنرن جو انتظام",
      "navbar_admin_reports": "رپورٽن جو انتظام",

      "report_btn": "رپورٽ ڪريو",
      "report_user_title": "{{name}} جي رپورٽ ڪريو",
      "report_user_desc": "مھرباني ڪري ھن استعمال ڪندڙ جي رپورٽ ڪرڻ جو سبب چونڊيو. اسان جي ايڊمن ٽيم ھن رپورٽ ۽ چيٽ جو جائزو وٺندي.",
      "submit_report_btn": "رپورٽ جمع ڪريو",
      "report_submitted_success": "رپورٽ ڪاميابي سان جمع ڪرائي وئي آھي. اسان جي ٽيم جلد ان جو جائزو وٺندي.",
      "cancel_btn": "رد ڪريو",

      // --- New Footer Links ---
      "footer_quick_links": "جلدي لنڪس",
      "footer_support": "مدد",
      "footer_follow_us": "اسان جي پيروي ڪريو",
      "faq_link": "عام سوال",
      "dispute_resolution_link": "تڪرار جو حل",
      "footer_privacy_policy": "پرائيويسي پاليسي",
      "footer_terms_of_service": "سروس جا شرط",
          // General Utility (Sindhi)
          "dark_mode_toggle": "اونداهي موڊ کي تبديل ڪريو",
          "change_language": "ٻولي تبديل ڪريو",
          "call_helpline": "هلپ لائن تي ڪال ڪريو",
          "by_label": "پاران",
          "remotely_label": "ريموٽلي",
          "anonymous_label": "گمنام",
          "women_only_zone_tag": "صرف عورتن جو علائقو",
          "not_specified": "بيان نه ڪيو ويو",
          "ok": "ٺيڪ آهي",
          "all_rights_reserved": "سڀ حق محفوظ.",
          "confirm": "تصديق ڪريو",
          "quick_actions": "تڪڙا قدم",
          
          // Request Modal Fixes (Sindhi)
          "specify_skill_wanted_label": "اهو مهارت ٻڌايو جيڪو توهان انهن کان چاهيو ٿا:",
          "request_skill_placeholder": "مثال طور، مون کي ويب ڊيزائن جي بدلي ۾ React.js ٽيوٽرنگ ۾ مدد جي ضرورت آهي.",
          "work_can_be_remote_label": "ڇا هي ڪم پري کان (آن لائن) ٿي سگهي ٿو؟",
          "location_label": "جڳهه",
          "enter_location_placeholder": "جڳهه داخل ڪريو...",
          "send_request_btn": "درخواست موڪليو",
          "sending_request_btn": "موڪلي رهيو آهي...",
          "initial_request_message": "اسلام عليڪم، مان مهارت جي مٽاسٽا جي درخواست ڪرڻ چاهيان ٿو: {{skill}}",
          "request_sent_success_title": "درخواست موڪلي وئي!",
          "request_sent_success_message": "درخواست ڪاميابيءَ سان موڪلي وئي!",
          "request_sent_error_title": "درخواست ناڪام!",
          "request_sent_error_message": "درخواست موڪلڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "please_specify_skill_error": "مهرباني ڪري اها مهارت بيان ڪريو جيڪا توهان بدلي ۾ چاهيو ٿا.",
          "location_required_non_remote_error": "روبرو درخواستن لاءِ جڳهه ضروري آهي.",
          "failed_to_send_request_error": "درخواست موڪلڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "access_denied_female_only": "رسائي رد ٿيل: هي علائقو صرف عورتن لاءِ آهي.",
          "failed_to_load_women_only_skills_error": "عورتن جي مهارتن کي لوڊ ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "failed_to_load_marketplace_skills_error": "مارڪيٽ جي مهارتن کي لوڊ ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",

          // Received Requests Page (Sindhi)
          "offered_by": "پيش ڪيل پاران",
          "received_requests_page_title": "موصول ٿيل درخواستون",
          "received_requests_page_subtitle": "ڪميونٽي جي ٻين ميمبرن کان مهارت جي تبادلي جي درخواستن جو انتظام ڪريو.",
          "no_requests_received": "توهان کي اڃا تائين ڪا به مهارت جي درخواست موصول نه ٿي آهي.",
          "requested_by": "درخواست ڪيل پاران",
          "offered_skill_label_in_request": "پيش ڪيل مهارت",
          "message_label": "پيغام",
          "date_received": "موصول ٿيڻ جي تاريخ",
          "accept_btn": "قبول ڪريو",
          "decline_btn": "رد ڪريو",
          "requested_your_skill": "توهان جي مهارت جي درخواست ڪئي وئي",
          "sender_offers_in_return": "موڪليندڙ بدلي ۾ پيش ڪري ٿو",
          "cancel_btn": "رد ڪريو",
          "request_accepted_by": "درخواست {{username}} پاران قبول ڪئي وئي! 🎉",
          "contact_them_to_coordinate": "هاڻي توهان انهن سان پنهنجي مهارت جي بدلي کي هموار ڪرڻ لاءِ رابطو ڪري سگهو ٿا.",
          "contact_details_heading": "رابطي جي تفصيل:",
          "name_label": "نالو",
          "phone_label": "فون",
          "offer_a_skill_title": "هڪ هنر پيش ڪريو",
"offer_a_skill_subtitle": "پنهنجي مهارت ڪميونٽي سان شيئر ڪريو",
"fill_all_required_fields": "مھرباني ڪري سڀ گهربل خانا ڀريو.",
"cover_photo_label": "ڪور فوٽو",
"click_to_upload": "تصوير اپلوڊ ڪرڻ لاءِ ڪلڪ ڪريو",
"skill_title_label": "هنر جو عنوان (مثال طور ويب ڊولپمينٽ، پلمبنگ)",
"skill_title_placeholder": "هنر لکو، کوما سان الڳ ڪريو...",
"description_label": "تفصيل",
"description_placeholder": "بيان ڪريو ته توهان ڇا ڪري سگهو ٿا...",
"skills_wanted_label": "بدلي ۾ گهربل هنر (اختياري)",
"skills_wanted_placeholder": "مثال طور گرافڪ ڊيزائن، باغباني...",
"location_label": "جڳهه",
"location_placeholder": "شهر، علائقو",
"remote_work_label": "ريموٽ ڪم",
"remote_work_desc": "سروس آن لائن مهيا ڪري سگهجي ٿي",
"post_anonymously_label": "گمنام پوسٽ ڪريو",
"post_anonymously_desc": "ڪارڊ تي پنهنجو نالو لڪايو",
"women_only_zone_label": "عورتن جو زون",
"women_only_zone_desc": "صرف عورتن کي نظر ايندو",
"post_skill_offer_btn": "هنر جي آڇ پوسٽ ڪريو",
"live_preview_title": "لائيو ڏيک",
"live_preview_desc": "توهان جو ڪارڊ مارڪيٽ پلیس ۾ ائين نظر ايندو.",
"your_skill_title": "توهان جي هنر جو عنوان",
"anonymous_user": "گمنام استعمال ڪندڙ",
"skill_posted_success_title": "هنر پوسٽ ٿي ويو!",
"skill_posted_success_message": "توهان جي هنر جي آڇ ڪاميابي سان مارڪيٽ پلیس ۾ پوسٽ ڪئي وئي آهي.",
"offer_publish_error_message": "هنر شايع ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "failed_to_load_requests_error": "درخواستون لوڊ ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "request_accepted_notification": "درخواست قبول ٿي وئي! استعمال ڪندڙ کي مطلع ڪيو ويو آهي.",
          "failed_to_accept_request_error": "درخواست قبول ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشٽ ڪريو.",
          "request_cancelled_notification": "درخواست رد ڪئي وئي.",
          "failed_to_cancel_request_error": "درخواست رد ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "pending_requests_section_title": "زير التوا درخواستون",
          "accepted_requests_section_title": "قبول ڪيل درخواستون",
          "no_new_requests_message_p1": "توهان وٽ هن وقت ڪا به نئين مهارت جي درخواست يا قبول ٿيل مٽاسٽا نه آهي.",
          "no_new_requests_message_p2": "جڏهن ڪو توهان جي مهارتن مان ڪنهن هڪ جي درخواست ڪندو ته اها هتي ظاهر ٿيندي.",
          "your_request_accepted_by": "توهان جي درخواست قبول ڪئي وئي",
          "message_btn": "پيغام",


          // Navbar (Sindhi)
          "navbar_home": "گھر",
          "navbar_about_us": "اسان بابت",
          "navbar_women_zone": "خاتونن لاءِ مخصوص علائقو",
          "navbar_contact": "رابطو",
          "navbar_login_btn": "لاگ ان ٿيو",
          "navbar_signup_btn": "سائن اپ ٿيو",
          "navbar_logout": "لاگ آئوٽ",
          "navbar_dashboard": "ڊيش بورڊ",
          "navbar_my_profile": "منهنجو پروفائل",
          "navbar_my_skills": "منهنجيون صلاحيتون",
          "navbar_messages": "پيغام",
          "navbar_marketplace": "مارڪيٽ پليس",
          "navbar_reviews": "جائزه",
          "navbar_notifications": "اطلاعات",
          "navbar_helpline": "مدد",

          // Hero Section (Sindhi)
          "hero_headline": "مهارتن جو تبادلو، مستقبل جي تعمير.",
          "hero_subtext": "گڊ ڪام – اسڪل سوائيپ پاڪستان هڪ اهڙي ڪميونٽي آهي جتي توهان پنهنجي صلاحيتن کي گهربل مدد لاءِ مٽائي سگهو ٿا، بغير ڪنهن پئسي جي.",
          "hero_offer_skill_btn": "مهارت پيش ڪريو",
          "hero_find_skill_btn": "مهارت ڳوليو",
          "hero_title": "مقامي صلاحيتن سان ڳنڍيو",
          "hero_subtitle": "پاڪستان ۾ مقامي خدمتون ڳولڻ ۽ پيش ڪرڻ لاءِ توهان جو هڪ اسٽاپ منزل.",
          "hero_join_now": "هاڻي شامل ٿيو",
          "hero_find_service": "خدمت ڳوليو",
          "hero_find_service_desc": "پنهنجي علائقي ۾ ماهر پيشه ورن پاران پيش ڪيل خدمتن جي وسيع رينج کي براؤز ڪريو.",
          "hero_offer_skills": "پنهنجيون صلاحيتون پيش ڪريو",
          "hero_offer_skills_desc": "هڪ پروفائل ٺاهيو ۽ ڪميونٽي کي پنهنجيون خدمتون پيش کرکے ڪمائڻ شروع ڪريو.",
          "hero_secure_reliable": "محفوظ ۽ قابل اعتماد",
          "hero_secure_reliable_desc": "اسان سڀني ٽرانزيڪشن ۽ رابطن لاءِ هڪ محفوظ پليٽ فارم فراهم ڪندا آهيون.",
          

          // How It Works Section (Sindhi)
          "how_it_works_title": "اهو ڪيئن ڪم ڪري ٿو",
          "how_it_works_subtitle": "اسان جي ڪميونٽي ۾ شامل ٿيڻ آسان آهي. مهارتن جو تبادلو شروع ڪرڻ لاءِ ان سادي قدمن تي عمل ڪريو.",
          "step1_title": "1. پروفائل ٺاهيو",
          "step1_description": "سائن اپ ڪريو ۽ پنهنجي پيش ڪيل مهارتن جي لسٽ ٺاهيو. اعتماد پيدا ڪرڻ لاءِ تصديق ڪرايو.",
          "step2_title": "2. ڳوليو ۽ تبادلو ڪريو",
          "step2_description": "توهان کي گهربل مهارتون براؤز ڪريو، يا درخواست پوسٽ ڪريو. تبادلي جو انتظام ڪرڻ لاءِ ٻين سان رابطو ڪريو.",
          "step3_title": "3. درجه بندي ڪريو ۽ ڪمايو",
          "step3_description": "تبادلو مڪمل ڪريو، راءِ ڏيو، ۽ پنهنجي تعاون لاءِ اسڪل پوائنٽس حاصل ڪريو.",

          // Featured Skills Section (Sindhi)
          "featured_skills_title": "نمايان مهارتون",
          "view_all_link": "سڀ ڏسو →",
          "view_details_link": "تفصيل ڏسو →",

          // Testimonials Section (Sindhi)
          "testimonials_title": "اسان جي ڪميونٽي ڇا چوي ٿي",
          "testimonial1_quote": "مون پنهنجي پاڙيسريءَ جو واٽر پمپ ٺيڪ ڪيو، ۽ ان جي بدلي ۾، سندس گهر واريءَ منهنجي ڌيءَ کي ڪڙهائي سکاري. گڊ ڪام – اسڪل سوائيپ اهو ممڪن ڪيو. اهو اسان جي ڳوٺ لاءِ هڪ نعمت آهي.",
          "testimonial1_author_name": "اقبال حسين",
          "testimonial1_author_details": "مڪينڪ، پنجاب",
          "testimonial2_quote": "هڪ عورت جي حيثيت سان، ڪم ڳولڻ هميشه آسان ناهي. عورتن لاءِ مخصوص علائقي ذريعي، مون کي پنهنجي سلائي جي مهارت پيش ڪرڻ ۽ هڪ ٻي عورت کان اڪائونٽنگ سکڻ لاءِ هڪ محفوظ جاءِ ملي.",
          "testimonial2_author_name": "ثمينا اختر",
          "testimonial2_author_details": "گھر جي رڌڻي، سنڌ",

          // Women's Zone Section (Sindhi)
          "women_zone_title": "خاتونن لاءِ هڪ محفوظ جاءِ",
          "women_zone_description": "اسان جو عورتن لاءِ مخصوص اسڪل زون عورتن کي اعتماد سان شيئر ڪرڻ، سکڻ ۽ مهارتن جو تبادلو ڪرڻ لاءِ هڪ محفوظ ۽ مددگار ماحول فراهم ڪري ٿو.",
          "women_zone_button": " جي زون کي ڳوليو",

          // Footer (Sindhi)
          "footer_tagline": "مهارتن کي ڳنڍڻ، بغير نقد، جي ذريعي ڪميونٽين کي بااختيار بڻائڻ.",
          "footer_quick_links": "تڪڙا لنڪ",
          "footer_support": "مدد",
          "footer_follow_us": "اسان جي پيروي ڪريو",
          "footer_copyright": "گڊ ڪام – اسڪل سوائيپ پاڪستان. سڀ حق محفوظ.",
          "footer_privacy_policy": "پرائيويسي پاليسي",
          "footer_terms_of_service": "سروس جون شرطون",
          "Empowering_communities_by_connecting_skills_cash_free": "مهارتن کي نقد جي بغير جوڙي ڪميونٽين کي بااختيار بڻائڻ.",
          "post_a_skill": "هڪ مهارت پوسٽ ڪريو",
          "faq_link": "اڪثر پڇيا ويندڙ سوال",
          "dispute_resolution_link": "تڪرار جو حل",

          // Language names for display (Sindhi)
          "lang_en": "انگريزي",
          "lang_ur": "اردو",
          "lang_sd": "سنڌي",

          // --- Dashboard Translations (Sindhi) ---
          "dashboard_welcome_heading": "ڀليڪار، {{username}}!",
          "dashboard_sub_heading": "هتي توهان جي اسڪل سوائيپ سرگرمي جو هڪ تڪڙو جائزو آهي.",
          "skills_offered_title": "پيش ڪيل صلاحيتون",
          "skills_offered_detail": "شروع ڪرڻ لاءِ هڪ مهارت پوسٽ ڪريو!",
          "skills_received_title": "حاصل ڪيل صلاحيتون",
          "skills_received_detail": "اڄ ئي نيون شيون سکڻ شروع ڪريو!",
          "unread_messages_title": "اڻ پڙهيل پيغام",
          "unread_messages_detail": "اڃا تائين ڪو نئون پيغام ناهي.",
          "find_skill_title": "هڪ مهارت ڳوليو",
          "find_skill_description": "پنهنجي ڪميونٽي ۾ نيون صلاحيتون دريافت ڪرڻ ۽ باصلاحيت ماڻهن سان ڳنڍڻ لاءِ مارڪيٽ پليس کي ڳوليو.",
          "browse_marketplace_btn": "مارڪيٽ پليس براؤز ڪريو",
          "offer_skill_title_card": "هڪ مهارت پيش ڪريو",
          "offer_skill_description_card": "پنهنجي ماهر کي ڪميونٽي سان شيئر ڪريو. هڪ مهارت پوسٽ ڪريو جيڪا توهان سيکاري سگهو ٿا يا هڪ خدمت جيڪا توهان فراهم ڪري سگهو ٿا.",
          "post_new_skill_btn": "نئين مهارت پوسٽ ڪريو",

          // --- Profile Page Translations (Sindhi) ---
          "profile_page_title": "منهنجو پروفائل",
          "profile_update_prompt": "پنهنجي تصوير ۽ ذاتي تفصيل هتي اپڊيٽ ڪريو.",
          "change_picture_btn": "تصوير تبديل ڪريو",
          "full_name_label": "پورو نالو",
          "email_address_label": "اي ميل پتو",
          "phone_number_label": "فون نمبر",
          "location_label": "جڳھ",
          "about_me_label": "منهنجي باري ۾",
          "discard_changes_btn": "تبديليون رد ڪريو",
          "save_changes_btn": "تبديليون محفوظ ڪريو",
          "my_badges_title": "منهنجا بيجز",

          // --- Offer Skill Page Translations (Sindhi) ---
          "offer_skill_title": "هڪ نئين مهارت پيش ڪريو",
          "women-only-banner":"عورتن لاءِ محفوظ ۽ تصديق ٿيل جاءِ",
          "women_only_zone_banner_text":"عورتن لاءِ محفوظ ۽ تصديق ٿيل جاءِ",
          "welcome-msg" : "hi",
          "offer_skill_subtitle": "پنهنجيون صلاحيتون شيئر ڪريو ۽ پنهنجي ڪميونٽي ۾ ٻين سان ڳنڍيو!",
          "step1_offer_skill": "قدم 1: توهان ڇا پيش ڪري سگهو ٿا؟",
          "step1_offer_skill_desc": "پنهنجي ماهر کي شيئر ڪريو ۽ ڪجهه نئون سکڻ دوران ٻين جي مدد ڪريو! هيٺ ڏنل فهرست مان 3 تائين صلاحيتون چونڊيو جن ۾ توهان کي پورو اعتماد آهي، يا پنهنجي ڳوليو.",
          "step1_offer_skill_label": "ڪهڙيون اعليٰ صلاحيتون توهان ٻين کي پيش ڪرڻ چاهيندا؟",
          "step1_offer_skill_placeholder": "پيش ڪرڻ لاءِ صلاحيتون ڳوليو...",
          "step2_offer_skill": "قدم 2: وڌيڪ تفصيل شامل ڪريو",
          "step2_offer_skill_desc": "پنهنجي لسٽ کي نمايان ڪرڻ لاءِ هڪ اختياري تصوير ۽ تفصيل شامل ڪريو. ماڻهن کي توهان سان ڳنڍڻ ۾ مدد لاءِ پنهنجو مقام ۽ رابطي جي تفصيل فراهم ڪريو.",
          "step2_photo_label": "هڪ تصوير اپلوڊ ڪريو (اختیاری)",
          "step2_description_label": "تفصيل",
          "step2_description_placeholder": "توهان جيڪو پيش ڪري رهيا آهيو ان جي وڌيڪ تفصيل سان وضاحت ڪريو...",
          "step2_location_label": "جڳھ",
          "step2_location_placeholder": "مثال طور، لاهور، پاڪستان",
          "step2_go_anonymous_switch": "گمنام رهو",
          "step2_remotely_switch": "دور کان دستياب",
          "step2_women_zone_switch": "عورتن لاءِ مخصوص علائقي ۾ شيئر ڪريو",
          "step3_offer_skill": "قدم 3: بدلي ۾ توهان ڇا چاهيو ٿا؟",
          "step3_offer_skill_desc": "اسان کي ٻڌايو ته توهان ڪهڙين صلاحيتن جو تبادلو ڪرڻ چاهيو ٿا ۽ نوان موقعا دريافت ڪريو! فهرست مان 3 تائين صلاحيتون چونڊيو جيڪي توهان سکڻ يا بهتر ڪرڻ چاهيو ٿا.",
          "step3_offer_skill_label": "ڪهڙيون نيون صلاحيتون توهان تبادلو ڪرڻ لاءِ پرجوش آهيو؟",
          "step3_offer_skill_placeholder": "سکڻ لاءِ صلاحيتون ڳوليو...",
          "step4_offer_skill": "قدم 4: جائزو وٺو ۽ شايع ڪريو",
          "step4_offer_skill_desc": "مهرباني ڪري هيٺ ڏنل سڀني تفصيلن جو جائزو وٺو. جيڪڏهن سڀ ڪجهه ٺيڪ آهي، پنهنجي پيشڪش کي مارڪيٽ پليس تي شايع ڪريو.",
          "step4_review_message": "تصديق ڪري، توهان اسان جي سروس جي شرطن ۽ رازداري پاليسي سان متفق آهيو.",
          "step4_confirm_publish_btn": "تصديق ڪريو ۽ شايع ڪريو",
          "go_back_btn": "واپس",
          "next_btn": "اڳيون",

          // --- My Skills Page Translations (Sindhi) ---
          "my_skills_page_title": "منهنجيون پيش ڪيل صلاحيتون",
          "my_skills_page_subtitle": "پنهنجي فعال مهارت جي پيشڪش جو انتظام ڪريو ۽ انهن جي ڪارڪردگي کي ٽريڪ ڪريو.",
          "no_skills_offered": "توهان اڃا تائين ڪا به مهارت پيش نه ڪئي آهي. شروع ڪرڻ لاءِ هڪ پوسٽ ڪريو!",
          "view_full_details_btn": "مڪمل تفصيل ڏسو",
          "delete_offer_btn": "پيشڪش حذف ڪريو",
          "offer_skill_label": "پيش ڪيل مهارت",
          "swap_skill_label": "گهربل مهارت",
          "description_label": "تفصيل",
          "skill_not_specified": "واضح نه ڪيل",
          "yes": "ها",
          "no": "نه",
          "failed_to_load_my_skills_error": "توهان جي مهارتن کي لوڊ ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "skill_offer_deleted_success": "مهارت جي پيشڪش ڪاميابي سان حذف ٿي وئي!",
          "failed_to_delete_skill_offer_error": "مهارت جي پيشڪش حذف ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "delete_confirm_title": "حذف ڪرڻ جي تصديق ڪريو",
          "delete_confirm_message": "ڇا توهان پڪ آهيو ته توهان هن مهارت جي پيشڪش کي حذف ڪرڻ چاهيو ٿا؟ هي عمل واپس نٿو وٺي سگهجي.",

          // --- Marketplace Page Translations (Sindhi) ---
          "marketplace_page_title": "مهارت مارڪيٽ پليس",
          "marketplace_page_subtitle": "پنهنجي ڪميونٽي ۾ ٻين پاران پيش ڪيل صلاحيتون ڳوليو.",
          "no_skills_available": "هن وقت مارڪيٽ پليس ۾ ڪا به مهارت دستياب ناهي. بعد ۾ ٻيهر چيڪ ڪريو!",
          "request_btn": "درخواست",
          "no_skills_available_from_others": "ٻين صارفين کان اڃا تائين ڪا به مهارت دستياب ناهي.",
          "no_skills_match_filters": "ڪابه مهارت توهان جي فلٽر سان ملندڙ ناهي.",
          "search_skills_placeholder": "مهارتون ڳوليو...",
          "no_categories_available": "ڪي به زمرا دستياب ناهن.",
          "clear_all_filters": "سڀ فلٽر صاف ڪريو",

          // --- Women Only Zone Page Translations (Sindhi) ---
          "women_only_zone_page_title": "خاتونن لاءِ مخصوص اسڪل زون",
          "women_only_zone_page_subtitle": "عورتن لاءِ هڪ وقف ٿيل جاءِ جتي هو محفوظ طور تي صلاحيتون شيئر ۽ تبادلو ڪري سگهن ٿيون.",
          "no_women_zone_skills_available": "هن وقت خاتونن لاءِ مخصوص زون ۾ ڪا به مهارت دستياب ناهي. بعد ۾ ٻيهر چيڪ ڪريو!",

          // --- Messages Page Translations (Sindhi) ---
          "messages_page_title": "منهنجا پيغام",
          "messages_page_subtitle": "ٻين استعمال ڪندڙن سان پنهنجي گفتگو ڏسو ۽ انتظام ڪريو.",
          "no_messages_yet": "توهان وٽ اڃا تائين ڪو به پيغام ناهي.",
          "search_messages_placeholder": "پيغام ڳوليو...",
          "no_messages_found": "ڪوبه پيغام نه مليو.",
          "select_conversation_message": "ڳالهه ٻولهه چونڊيو",
          "choose_chat_to_start": "ڳالهه ٻولهه شروع ڪرڻ لاءِ کاٻي پاسي کان هڪ چيٽ چونڊيو.",
          "chat_with_user_placeholder": "چيٽ",
          "skill_received_btn": "مهارت وصول ٿي",
          "report_btn": "رپورٽ ڪريو",
          "type_your_message_placeholder": "هتي پنهنجو پيغام لکو...",
          "chat_initial_greeting": "هيلو! اڄ مان توهان جي ڪيئن مدد ڪري سگهان ٿو؟",
          "chat_how_can_i_help": "مان تيار آهيان جڏهن توهان تيار آهيو!",
          "chat_user_response": "سٺو، مان ان جو انتظار ڪري رهيو آهيان!",
          "chat_message_ali": "ضرور، سڀاڻي ملنداسين.",
          "chat_message_fatima": "مون کي مهارت وصول ٿي وئي!",
          "chat_message_usman": "نئين درخواست لاءِ شروعاتي پيغام.",
          "chat_message_ayesha": "مٽاسٽا مڪمل ٿي وئي. مهرباني ڪري هڪ جائزو ڇڏيو!",
          "exchange_completed_chat_view_only": "هي مٽاسٽا مڪمل ٿي وئي آهي. هاڻي توهان پيغام موڪلي يا وصول نٿا ڪري سگهو.",
          "exchange_completed_no_chat": "هي مٽاسٽا مڪمل ٿي وئي آهي.",
          "exchange_completed_chat_summary": "مٽاسٽا مڪمل ٿي وئي. مهرباني ڪري هڪ جائزو ڇڏيو!",
          "confirm_skill_received_title": "مهارت وصول ٿيڻ جي تصديق ڪريو؟",
          "confirm_skill_received_message": "ڇا توهان واقعي مهارت وصول ڪئي؟ هي عمل واپس نٿو وٺي سگهجي ۽ جائزو وٺڻ واري عمل ڏانهن وڌندو.",
          "error_confirming_skill_received": "مهارت وصول ٿيڻ جي تصديق ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "error_confirming_skill_received_generic": "مهارت وصول ٿيڻ جي تصديق ڪرڻ ۾ ناڪامي. هڪ خرابي پيش آئي.",
          "error_no_request_id": "مهارت جي تصديق نه ٿي سگهي. درخواست ID غائب آهي.",
          "error_title": "خرابي",
          "your_confirmation_pending": "توهان جي تصديق زير التوا آهي",
          "partner_confirmation_pending": "شريڪ جي تصديق زير التوا آهي",
          "exchange_completed_label": "مٽاسٽا مڪمل ٿي وئي",

          // --- Reviews Page Translations (Sindhi) ---
          "reviews_page_title": "جائزا",
          "reviews_page_subtitle": "مڪمل ٿيل مهارت جي مٽاسٽا تي پنهنجي راءِ ڏيو ۽ موصول ٿيل جائزو ڏسو.",
          "no_reviews_yet": "توهان کي اڃا تائين ڪو به جائزو موصول نه ٿيو آهي.",
          "review_submitted_title": "جائزو جمع ڪرايو ويو!",
          "review_submitted_message": "توهان جي راءِ جي مهرباني. توهان جو جائزو ڪميونٽي ۾ اعتماد پيدا ڪرڻ ۾ مدد ڪري ٿو.",
          "back_to_dashboard_btn": "ڊيش بورڊ ڏانهن واپس",
          "rate_skill_exchange_with": "پنهنجي مهارت جي مٽاسٽا کي {{username}} سان درجه بندي ڪريو",
          "your_review_label": "توهان جو جائزو",
          "review_placeholder": "هتي پنهنجو جائزو لکو...",
          "endorse_skills_label": "{{username}} لاءِ صلاحيتن جي تصديق ڪريو",
          "endorse_btn": "تصديق ڪريو",
          "submit_review_btn": "جائزو جمع ڪريو",
          "reviews_received_tab": "وصول ٿيل جائزا",
          "write_a_review_tab": "جائزو لکو",
          "no_received_reviews_yet": "توهان کي اڃا تائين ڪو به جائزو موصول نه ٿيو آهي.",
          "no_pending_reviews": "ڪو به زير التوا جائزو ناهي. سڀئي مڪمل ٿيل مٽاسٽا توهان طرفان جائزو ورتا ويا آهن!",
          "review_for_exchange_with": "{{username}} سان مٽاسٽا لاءِ جائزو",
          "skills_involved": "شامل صلاحيتون:",
          "skill_offered_by_them": "انهن پاران پيش ڪيل مهارت:",
          "skill_you_requested": "توهان جي گهربل مهارت:",
          "rating_label": "درجه بندي:",
          "by_reviewer_name": "پاران {{username}}",
          "failed_to_submit_review": "جائزو جمع ڪرڻ ۾ ناڪامي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "failed_to_load_received_reviews": "وصول ٿيل جائزو لوڊ ڪرڻ ۾ ناڪامي.",
          "failed_to_load_pending_reviews": "زير التوا جائزو لوڊ ڪرڻ ۾ ناڪامي.",
          "review_submission_status": "جائزو جمع ڪرائڻ جي حالت",
          "review_submitted_success": "توهان جو جائزو ڪاميابي سان جمع ڪرايو ويو آهي!",
          "failed_to_submit_review_error": "جائزو جمع ڪرڻ ۾ ناڪام. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "please_provide_rating": "مهرباني ڪري درجه بندي ڏيو.",
          "please_provide_review_comment": "مهرباني ڪري هڪ جائزو تبصرو ڏيو.",
          "your_comments_label": "توهان جا تبصرا",
          "review_comment_placeholder": "پنهنجو تجربو حصيداري ڪريو...",
          "rate_exchange_label": "هن مٽاسٽا جي درجه بندي ڪريو",
          "write_review_for_label": "{{username}} لاءِ جائزو لکو",
          "no_received_reviews": "اڃا تائين ڪوبه جائزو وصول نه ٿيو آهي.",
          "received_reviews_tab": "وصول ٿيل جائزا",
          "endorse_skills_optional": "مهارت جي تصديق (اختياري)",

          // --- Login Page Translations (Sindhi) ---
          "login_welcome_back": "ڀليڪار!",
          "login_access_account": "پنهنجي اڪائونٽ تائين رسائي ۽ صلاحيتن جو تبادلو شروع ڪرڻ لاءِ لاگ ان ٿيو.",
          "login_credential_label": "اي ميل، يوزر نالو، يا سي اين آءِ سي",
          "login_credential_placeholder": "پنهنجي سندون داخل ڪريو",
          "login_password_placeholder": "پنهنجو پاسورڊ داخل ڪريو",
          "login_forgot_password": "پاسورڊ وسري ويو؟",
          "login_logging_in": "لاگ ان ٿي رهيو آهي...",
          "login_no_account_prompt": "اڪائونٽ ناهي؟",
          "login_success_message": "توهان ڪاميابي سان لاگ ان ٿي ويا آهيو!",
          "login_unexpected_error": "لاگ ان دوران هڪ اڻڄاتل خرابي پيش آئي. مهرباني ڪري ٻيهر ڪوشش ڪريو.",
          "login_success_title": "لاگ ان ڪامياب!",

          // --- Signup Page Translations (Sindhi) ---
          "signup_join_gadd_kaam": "گڊ ڪام ۾ شامل ٿيو",
          "signup_start_offering_finding": "توهان جي ڪميونٽي ۾ مهارتون پيش ڪرڻ ۽ ڳولڻ شروع ڪرڻ لاءِ هڪ اڪائونٽ ٺاهيو.",
          "signup_firstName_label": "پهريون نالو",
          "signup_firstName_placeholder": "توهان جو پهريون نالو",
          "signup_lastName_label": "آخري نالو",
          "signup_lastName_placeholder": "توهان جو آخري نالو",
          "signup_profilePicture_label": "پروفائل تصوير",
          "signup_no_file_chosen": "ڪابه فائل چونڊيل ناهي.",
          "signup_username_label": "يوزر نالو",
          "signup_username_placeholder": "هڪ يوزر نالو چونڊيو",
          "signup_phoneNumber_label": "فون نمبر",
          "signup_email_label": "اي ميل",
          "signup_dateOfBirth_label": "ڄمڻ جي تاريخ",
          "signup_cnicNumber_label": "سي اين آءِ سي نمبر",
          "signup_cnicNumber_placeholder": "مثال طور، 12345-1234567-1",
          "signup_cnicFrontPic_label": "سي اين آءِ سي سامهون جي تصوير",
          "signup_cnicBackPic_label": "سي اين آءِ سي پٺيان جي تصوير",
          "signup_password_label": "پاسورڊ",
          "signup_confirmPassword_label": "پاسورڊ جي تصديق ڪريو",
          "signup_create_account_btn": "اڪائونٽ ٺاهيو",
          "signup_already_have_account": "اڳ ۾ ئي اڪائونٽ آهي؟",
          "signup_login_link": "لاگ ان ٿيو",
          "signup_success_message": "اڪائونٽ ڪاميابي سان ٺاهيو ويو! مهرباني ڪري لاگ ان ٿيو.",
          "signup_error_gender_required": "مهرباني ڪري توهان جي جنس چونڊيو.",
          "signup_unexpected_error": "سائن اپ دوران هڪ اڻڄاتل خرابي پيش آئي.",
          "signup_gender_label": "مرد يا عورت چونڊيو",
          "signup_gender_male": "مرد",
          "signup_gender_female": "عورت",
          "signup_creating_account": "اڪائونٽ ٺاهي رهيو آهي...",
          "signup_success_modal_title": "اڪائونٽ ٺهي ويو!",

          // Chatbot Translations (Sindhi)
          "chatbot_welcome_message": "گڊ ڪام – اسڪل سوائيپ پاڪستان ۾ ڀليڪار! 🤝\nصلاحيتن ۽ موقعن کي ڳنڍي ڪميونٽيز کي بااختيار بڻائڻ.\nمان اڄ توهان جي سنڌي يا اردو ۾ ڪيئن مدد ڪري سگهان ٿو؟ اسان جي مارڪيٽ پليس، عورتن لاءِ مخصوص زون، مهارتون پوسٽ ڪرڻ، يا FAQs ۽ تڪراري حل جهڙين مدد بابت ڪجهه به پڇو.",
          "chatbot_dummy_response": "مان هن وقت هڪ سادو AI اسسٽنٽ آهيان. گڊ ڪام بابت وڌيڪ معلومات سان مان توهان جي وڌيڪ ڪيئن مدد ڪري سگهان ٿو؟",
          "chatbot_input_placeholder": "هتي پنهنجو پيغام لکو...",

          // Helpline Popup (Sindhi)
          "helpline_popup_title": "گڊ ڪام هيلپ لائن",
          "helpline_number": "📞 +92-300-1234567",
          "helpline_note": "مدد لاءِ 24/7 دستياب آهي.",

          // Logout Confirmation (Sindhi)
          "logout_confirm_title": "لاگ آئوٽ جي تصديق ڪريو",
          "logout_confirm_message": "ڇا توهان پڪ آهيو ته توهان لاگ آئوٽ ڪرڻ چاهيو ٿا؟",
          "logout_cancel_btn": "نه، رد ڪريو",
          "logout_confirm_btn": "ها، لاگ آئوٽ ڪريو",
          "app_name": "گڏ ڪم",

      // Navbar
      "navbar_home": "هوم",
      "navbar_marketplace": "مارڪيٽ پليس",
      "navbar_women_zone": "عورتن جو زون",
      "navbar_about_us": "اسان جي باري ۾",
      "navbar_contact": "رابطو ڪريو",
      "navbar_helpline": "مدد مرڪز",
      "navbar_dashboard": "منهنجو ڊيش بورڊ",
      "navbar_logout": "لاگ آئوٽ",
      "navbar_login_btn": "لاگ ان",
      "navbar_signup_btn": "سائن اپ",

      // Hero
      "hero_headline_prefix": "مهارتن جو واپار، اڏيو",
      "hero_subtext": "پاڪستان ۾ مهارتن ۽ خدمتن جي واپار لاءِ سڀ کان وڌيڪ قابل اعتماد پليٽ فارم.",
      "hero_offer_skill_btn": "هڪ مهارت پيش ڪريو",
      "hero_find_skill_btn": "هڪ مهارت ڳولهيو",

      // How It Works
      "how_it_works_title": "هي ڪيئن ڪم ڪري ٿو",
      "how_it_works_subtitle": "شروع ڪرڻ لاءِ ٽي سادي مرحلا.",
      "step1_title": "پروفائل ٺاهيو",
      "step1_description": "سائن اپ ڪريو، پنهنجي سڃاڻپ جي تصديق ڪريو ۽ پورٽ فوليو ٺاهيو.",
      "step2_title": "ڳولا يا آڇ",
      "step2_description": "دستياب مهارتون ڏسو يا پنهنجون خدمتون لسٽ ڪريو.",
      "step3_title": "رابطو ۽ واپار",
      "step3_description": "ڳالهايو، شرطن تي اتفاق ڪريو، ۽ محفوظ طريقي سان مهارت مٽايو.",

      // Featured Skills
      "featured_skills_title": "نمويان مهارتون",
      "view_all_link": "سڀ ڏسو",
      "view_details_link": "تفصيل ڏسو",

      // Women's Zone
      "women_only_zone_tag": "صرف عورتن لاء",
      "women_zone_description": "عورتن لاءِ مهارتن جي واپار لاءِ هڪ محفوظ ۽ پرامن ماحول.",
      "women_zone_button": "زون ۾ داخل ٿيو",

      // Testimonials
      "testimonials_title": "اسان جي ڪميونٽي ڇا ٿي چوي",

      // Login Page
      "login_welcome_back": "ڀليڪار!",
      "login_access_account": "مهارتن ۽ درخواستن کي منظم ڪرڻ لاءِ پنهنجي اڪائونٽ تائين رسائي ڪريو.",
      "login_credential_label": "اي ميل، يوزر نيم، يا سڃاڻپ ڪارڊ",
      "login_credential_placeholder": "اي ميل، يوزر نيم، يا سڃاڻپ ڪارڊ داخل ڪريو",
      "login_password_placeholder": "پنهنجو پاسورڊ داخل ڪريو",
      "login_forgot_password": "پاسورڊ وساري ويٺا؟",
      "login_logging_in": "لاگ ان ٿي رهيو آهي...",
      "login_no_account_prompt": "اڪائونٽ ناهي؟",
      "login_success_title": "ڀليڪار!",
      "login_success_message": "لاگ ان ڪامياب. ريڊائريڪٽ ٿي رهيو آهي...",
      "login_unexpected_error": "لاگ ان ناڪام. مહેરٻاني ڪري پنهنجي معلومات چيڪ ڪريو.",

      // Signup Page
      "signup_join_gadd_kaam": "گڏ ڪم ۾ شامل ٿيو",
      "signup_start_offering_finding": "اڄ ئي پنهنجي مهارتون پيش ڪرڻ شروع ڪريو يا مدد ڳولهيو.",
      "signup_firstName_label": "پهريون نالو",
      "signup_firstName_placeholder": "پنهنجو پهريون نالو داخل ڪريو",
      "signup_lastName_label": "آخري نالو",
      "signup_lastName_placeholder": "پنهنجو آخري نالو داخل ڪريو",
      "signup_profilePicture_label": "پروفائل تصوير",
      "signup_username_label": "يوزر نيم",
      "signup_username_placeholder": "ڪو يوزر نيم چونڊيو",
      "signup_phoneNumber_label": "فون نمبر",
      "signup_email_label": "اي ميل ايڊريس",
      "signup_dateOfBirth_label": "پيدائش جي تاريخ",
      "signup_cnicNumber_label": "سڃاڻپ ڪارڊ نمبر",
      "signup_gender_label": "جنس",
      "signup_gender_male": "مرد",
      "signup_gender_female": "عورت",
      "signup_cnicFrontPic_label": "سڃاڻپ ڪارڊ جي اڳيان واري تصوير",
      "signup_cnicBackPic_label": "سڃاڻپ ڪارڊ جي پوئين تصوير",
      "signup_password_label": "پاسورڊ",
      "signup_confirmPassword_label": "پاسورڊ جي تصديق ڪريو",
      "signup_creating_account": "اڪائونٽ ٺهي رهيو آهي...",
      "signup_create_account_btn": "اڪائونٽ ٺاهيو",
      "signup_already_have_account": "اڳ ۾ ئي اڪائونٽ آهي؟",
      "signup_login_link": "لاگ ان ٿيو",
      "signup_error_passwords_mismatch": "پاسورڊ ميچ نه پيا ڪن.",
      "signup_error_gender_required": "مھرباني ڪري جنس چونڊيو.",
      "signup_success_message": "اڪائونٽ ڪاميابي سان ٺهي ويو! ريڊائريڪٽ ٿي رهيو آهي...",
      "signup_success_modal_title": "ڪاميابي",
      "signup_unexpected_error": "هڪ اڻڄاتل خرابي پيش آئي. مھرباني ڪري ٻيهر ڪوشش ڪريو."
          
           
        },
      },
    },
  });

export default i18n;

